/* tslint:disable */
/* eslint-disable */

export interface HttpClient {

    request<R>(requestConfig: { method: string; url: string; queryParams?: any; data?: any; copyFn?: (data: R) => R; }): RestResponse<R>;
}

export class RestApplicationClient {

    constructor(protected httpClient: HttpClient) {
    }

    /**
     * HTTP GET /rest
     * Java method: com.cubeia.nano.player.web.RootController.root
     */
    root$GET$rest(): RestResponse<string> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`rest` });
    }

    /**
     * HTTP GET /rest/bonus/active
     * Java method: com.cubeia.nano.player.web.UserBonusController.listActiveBonuses
     */
    listActiveBonuses(): RestResponse<UserBonusView[]> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`rest/bonus/active` });
    }

    /**
     * HTTP GET /rest/bonus/cancel/offer/all
     * Java method: com.cubeia.nano.player.web.UserBonusController.cancelAllBonusOffers
     */
    cancelAllBonusOffers(): RestResponse<void> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`rest/bonus/cancel/offer/all` });
    }

    /**
     * HTTP GET /rest/bonus/cancel/offer/{offerId}
     * Java method: com.cubeia.nano.player.web.UserBonusController.cancelBonusOffer
     */
    cancelBonusOffer(offerId: number): RestResponse<void> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`rest/bonus/cancel/offer/${offerId}` });
    }

    /**
     * HTTP GET /rest/bonus/cancel/{userBonusId}
     * Java method: com.cubeia.nano.player.web.UserBonusController.cancelBonus
     */
    cancelBonus(userBonusId: number): RestResponse<void> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`rest/bonus/cancel/${userBonusId}` });
    }

    /**
     * HTTP GET /rest/bonus/casino-games/{bonusId}
     * Java method: com.cubeia.nano.player.web.UserBonusController.getIncludedGamesForBonus
     */
    getIncludedGamesForBonus(bonusId: number): RestResponse<{ [index: string]: number[] }> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`rest/bonus/casino-games/${bonusId}` });
    }

    /**
     * HTTP GET /rest/bonus/claim/{offerId}
     * Java method: com.cubeia.nano.player.web.UserBonusController.claimBonusOffer
     */
    claimBonusOffer(offerId: number): RestResponse<UserBonusView> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`rest/bonus/claim/${offerId}` });
    }

    /**
     * HTTP GET /rest/bonus/info/sportsbook/{currency}
     * Java method: com.cubeia.nano.player.web.UserBonusController.getSportsbookBonusInfo
     */
    getSportsbookBonusInfo(currency: string): RestResponse<BonusSportsbookInfo> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`rest/bonus/info/sportsbook/${currency}` });
    }

    /**
     * HTTP GET /rest/bonus/list
     * Java method: com.cubeia.nano.player.web.UserBonusController.listUserBonuses
     */
    listUserBonuses(): RestResponse<UserBonusListResponse> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`rest/bonus/list` });
    }

    /**
     * HTTP GET /rest/bonus/next-rewards/{currencyCode}
     * Java method: com.cubeia.nano.player.web.UserBonusController.listNextDepositRewards
     */
    listNextDepositRewards(currencyCode: string): RestResponse<DepositRewardConfig[]> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`rest/bonus/next-rewards/${currencyCode}` });
    }

    /**
     * HTTP GET /rest/bonus/next/{currencyCode}
     * Java method: com.cubeia.nano.player.web.UserBonusController.listNextBonuses
     */
    listNextBonuses(currencyCode: string): RestResponse<BonusUpcomingOffer[]> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`rest/bonus/next/${currencyCode}` });
    }

    /**
     * HTTP GET /rest/bonus/offers
     * Java method: com.cubeia.nano.player.web.UserBonusController.listBonusOffers
     */
    listBonusOffers(): RestResponse<BonusOffer[]> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`rest/bonus/offers` });
    }

    /**
     * HTTP GET /rest/casino/category/{id}
     * Java method: com.cubeia.nano.player.web.CasinoController.getCategory
     */
    getCategory(id: number): RestResponse<CasinoLobbyCategory> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`rest/casino/category/${id}` });
    }

    /**
     * HTTP GET /rest/casino/game/{gameId}/seo/{locale}
     * Java method: com.cubeia.nano.player.web.CasinoController.getCasinoGameSeo
     */
    getCasinoGameSeo(gameId: number, locale: string): RestResponse<CasinoGameLocaleSeo> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`rest/casino/game/${gameId}/seo/${locale}` });
    }

    /**
     * HTTP GET /rest/casino/jackpots
     * Java method: com.cubeia.nano.player.web.CasinoController.getJackpots
     */
    getJackpots(): RestResponse<JackpotList> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`rest/casino/jackpots` });
    }

    /**
     * HTTP GET /rest/casino/launch-demo/{gameId}/{locale}/{mobile}
     * Java method: com.cubeia.nano.player.web.CasinoController.launchGameInDemoMode
     */
    launchGameInDemoMode(gameId: number, locale: string, mobile: boolean): RestResponse<LaunchCasinoGameResponse> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`rest/casino/launch-demo/${gameId}/${locale}/${mobile}` });
    }

    /**
     * HTTP GET /rest/casino/launch/{gameId}/{currencyCode}/{mobile}/{locale}
     * Java method: com.cubeia.nano.player.web.CasinoController.launchGame
     */
    launchGame(gameId: number, currencyCode: string, mobile: boolean, locale: string, queryParams?: { ignoreCountryBlock?: boolean; }): RestResponse<LaunchCasinoGameResponse> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`rest/casino/launch/${gameId}/${currencyCode}/${mobile}/${locale}`, queryParams: queryParams });
    }

    /**
     * HTTP GET /rest/casino/lite/lobby
     * Java method: com.cubeia.nano.player.web.CasinoController.getCasinoLobbyLite
     */
    getCasinoLobbyLite(): RestResponse<string> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`rest/casino/lite/lobby` });
    }

    /**
     * HTTP GET /rest/casino/lite/lobby-dto
     * Java method: com.cubeia.nano.player.web.CasinoController.getCasinoLobbyDtoLite
     */
    getCasinoLobbyDtoLite(): RestResponse<CasinoSortedLobby> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`rest/casino/lite/lobby-dto` });
    }

    /**
     * HTTP GET /rest/casino/lobby
     * Java method: com.cubeia.nano.player.web.CasinoController.getCasinoLobby
     */
    getCasinoLobby(): RestResponse<string> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`rest/casino/lobby` });
    }

    /**
     * HTTP GET /rest/casino/lobby-dto
     * Java method: com.cubeia.nano.player.web.CasinoController.getCasinoLobbyDto
     */
    getCasinoLobbyDto(): RestResponse<CasinoLobby> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`rest/casino/lobby-dto` });
    }

    /**
     * HTTP GET /rest/casino/seo/{locale}
     * Java method: com.cubeia.nano.player.web.CasinoController.getCasinoAdminSeo
     */
    getCasinoAdminSeo(locale: string): RestResponse<CasinoAdminLocaleSeo> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`rest/casino/seo/${locale}` });
    }

    /**
     * HTTP GET /rest/casino/v2/lobby
     * Java method: com.cubeia.nano.player.web.CasinoController.getCasinoLobbyV2
     */
    getCasinoLobbyV2(): RestResponse<string> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`rest/casino/v2/lobby` });
    }

    /**
     * HTTP GET /rest/casino/v2/lobby-dto
     * Java method: com.cubeia.nano.player.web.CasinoController.getCasinoLobbyDtoV2
     */
    getCasinoLobbyDtoV2(): RestResponse<CasinoSortedLobby> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`rest/casino/v2/lobby-dto` });
    }

    /**
     * HTTP GET /rest/communication/marketing/email/subscribe
     * Java method: com.cubeia.nano.player.web.SubscriptionController.subscribeEmailMarketing
     */
    subscribeEmailMarketing(queryParams: { endpoint: string; hash: number; }): RestResponse<void> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`rest/communication/marketing/email/subscribe`, queryParams: queryParams });
    }

    /**
     * HTTP GET /rest/communication/marketing/email/unsubscribe
     * Java method: com.cubeia.nano.player.web.SubscriptionController.unsubscribeEmailMarketing
     */
    unsubscribeEmailMarketing(queryParams: { endpoint: string; hash: number; }): RestResponse<string> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`rest/communication/marketing/email/unsubscribe`, queryParams: queryParams });
    }

    /**
     * HTTP GET /rest/communication/marketing/sms/subscribe
     * Java method: com.cubeia.nano.player.web.SubscriptionController.subscribeSmsMarketing
     */
    subscribeSmsMarketing(queryParams: { endpoint: string; hash: number; }): RestResponse<void> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`rest/communication/marketing/sms/subscribe`, queryParams: queryParams });
    }

    /**
     * HTTP GET /rest/communication/marketing/sms/unsubscribe
     * Java method: com.cubeia.nano.player.web.SubscriptionController.unsubscribeSmsMarketing
     */
    unsubscribeSmsMarketing(queryParams: { endpoint: string; hash: number; }): RestResponse<void> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`rest/communication/marketing/sms/unsubscribe`, queryParams: queryParams });
    }

    /**
     * HTTP GET /rest/css
     * Java method: com.cubeia.nano.player.web.RootController.getCssOverride
     */
    getCssOverride(): RestResponse<string> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`rest/css` });
    }

    /**
     * HTTP GET /rest/error
     * Java method: com.cubeia.nano.player.web.RootController.writeErrorToLog
     */
    writeErrorToLog(): RestResponse<void> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`rest/error` });
    }

    /**
     * HTTP GET /rest/maintenance
     * Java method: com.cubeia.nano.player.web.MaintenanceController.getMaintenanceWindows
     */
    getMaintenanceWindows(): RestResponse<MaintenanceAndServerTime> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`rest/maintenance` });
    }

    /**
     * HTTP POST /rest/messages/deliver
     * Java method: com.cubeia.nano.player.web.MessageController.deliverUserMessages
     */
    deliverUserMessages(): RestResponse<ListUserMessageResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`rest/messages/deliver` });
    }

    /**
     * HTTP POST /rest/messages/list
     * Java method: com.cubeia.nano.player.web.MessageController.getUserMessageList
     */
    getUserMessageList(listRequest: ListUserMessageRequest): RestResponse<ListMinimalUserMessageProjectionResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`rest/messages/list`, data: listRequest });
    }

    /**
     * HTTP GET /rest/messages/mark/all-read
     * Java method: com.cubeia.nano.player.web.MessageController.markAllMessagesRead
     */
    markAllMessagesRead(): RestResponse<void> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`rest/messages/mark/all-read` });
    }

    /**
     * HTTP GET /rest/messages/mark/read/{messageId}
     * Java method: com.cubeia.nano.player.web.MessageController.markMessageRead
     */
    markMessageRead(messageId: number): RestResponse<void> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`rest/messages/mark/read/${messageId}` });
    }

    /**
     * HTTP GET /rest/messages/{messageId}
     * Java method: com.cubeia.nano.player.web.MessageController.getMessageAndMarkAsRead
     */
    getMessageAndMarkAsRead(messageId: number): RestResponse<UserMessage> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`rest/messages/${messageId}` });
    }

    /**
     * HTTP GET /rest/notifications
     * Java method: com.cubeia.nano.player.web.notifications.NotificationController.root
     */
    root$GET$rest_notifications(): RestResponse<string> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`rest/notifications` });
    }

    /**
     * HTTP GET /rest/notifications/key
     * Java method: com.cubeia.nano.player.web.notifications.NotificationController.getPublicKey
     */
    getPublicKey(): RestResponse<string> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`rest/notifications/key` });
    }

    /**
     * HTTP POST /rest/notifications/subscribe
     * Java method: com.cubeia.nano.player.web.notifications.NotificationController.subscribe
     */
    subscribe(subscription: PushSubscription): RestResponse<void> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`rest/notifications/subscribe`, data: subscription });
    }

    /**
     * HTTP GET /rest/notifications/subscribing
     * Java method: com.cubeia.nano.player.web.notifications.NotificationController.isSubscribing
     */
    isSubscribing(queryParams: { endpoint: string; }): RestResponse<boolean> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`rest/notifications/subscribing`, queryParams: queryParams });
    }

    /**
     * HTTP POST /rest/notifications/unsubscribe
     * Java method: com.cubeia.nano.player.web.notifications.NotificationController.unsubscribe
     */
    unsubscribe(subscription: PushSubscription): RestResponse<void> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`rest/notifications/unsubscribe`, data: subscription });
    }

    /**
     * HTTP GET /rest/onramper/launch/{currencyCode}
     * Java method: com.cubeia.nano.player.web.onramper.OnramperController.getLaunchUrl
     */
    getLaunchUrl(currencyCode: string): RestResponse<OnramperLaunchResponse> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`rest/onramper/launch/${currencyCode}` });
    }

    /**
     * HTTP GET /rest/payments/deposit/context/{provider}/{method}/{currencyCode}
     * Java method: com.cubeia.nano.player.web.PaymentsController.getDepositContext
     */
    getDepositContext(provider: string, method: string, currencyCode: string): RestResponse<DepositContext> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`rest/payments/deposit/context/${provider}/${method}/${currencyCode}` });
    }

    /**
     * HTTP POST /rest/payments/deposit/perform/{paymentId}
     * Java method: com.cubeia.nano.player.web.PaymentsController.performDeposit
     */
    performDeposit(paymentId: number, customerInfo: CustomerInfo): RestResponse<DepositResult> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`rest/payments/deposit/perform/${paymentId}`, data: customerInfo });
    }

    /**
     * HTTP POST /rest/payments/list-projections
     * Java method: com.cubeia.nano.player.web.PaymentsController.listProjections
     */
    listProjections(listSessionUserPaymentsRequest: ListSessionUserPaymentsRequest): RestResponse<GenericUnPagedListResponse<PaymentMediumProjection>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`rest/payments/list-projections`, data: listSessionUserPaymentsRequest });
    }

    /**
     * HTTP GET /rest/payments/methods
     * Java method: com.cubeia.nano.player.web.PaymentsController.getPaymentMethods
     */
    getPaymentMethods(): RestResponse<{ [index: string]: PaymentMethod[] }> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`rest/payments/methods` });
    }

    /**
     * HTTP POST /rest/payments/payment-dialog/{provider}
     * Java method: com.cubeia.nano.player.web.PaymentsController.getDepositDialog
     */
    getDepositDialog(provider: string, order: PlayerOrder): RestResponse<PaymentDialog> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`rest/payments/payment-dialog/${provider}`, data: order });
    }

    /**
     * HTTP POST /rest/payments/voucher/redeem/{code}
     * Java method: com.cubeia.nano.player.web.PaymentsController.redeemVoucher
     */
    redeemVoucher(code: string): RestResponse<VoucherRedemptionResult> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`rest/payments/voucher/redeem/${code}` });
    }

    /**
     * HTTP GET /rest/payments/withdraw/cancel/{paymentId}
     * Java method: com.cubeia.nano.player.web.PaymentsController.cancelWithdraw
     */
    cancelWithdraw(paymentId: number): RestResponse<UpdatePaymentResponse> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`rest/payments/withdraw/cancel/${paymentId}` });
    }

    /**
     * HTTP GET /rest/payments/withdraw/context/{provider}/{method}/{currencyCode}
     * Java method: com.cubeia.nano.player.web.PaymentsController.getWithdrawContext
     */
    getWithdrawContext(provider: string, method: string, currencyCode: string): RestResponse<WithdrawContext> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`rest/payments/withdraw/context/${provider}/${method}/${currencyCode}` });
    }

    /**
     * HTTP POST /rest/payments/withdraw/{provider}
     * Java method: com.cubeia.nano.player.web.PaymentsController.requestWithdraw
     */
    requestWithdraw(provider: string, order: PlayerOrder): RestResponse<RequestWithdrawResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`rest/payments/withdraw/${provider}`, data: order });
    }

    /**
     * HTTP GET /rest/ping
     * Java method: com.cubeia.nano.player.web.RootController.simplePing
     */
    simplePing(): RestResponse<string> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`rest/ping` });
    }

    /**
     * HTTP GET /rest/poker/launch
     * Java method: com.cubeia.nano.player.web.PokerController.createPokerToken
     */
    createPokerToken(queryParams?: { currency?: string; }): RestResponse<LaunchUrl> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`rest/poker/launch`, queryParams: queryParams });
    }

    /**
     * HTTP GET /rest/poker/playercount
     * Java method: com.cubeia.nano.player.web.PokerController.getPokerPlayerCount
     */
    getPokerPlayerCount(): RestResponse<PokerPlayerCount> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`rest/poker/playercount` });
    }

    /**
     * HTTP GET /rest/properties
     * Java method: com.cubeia.nano.player.web.ConfigController.getClientConfig
     */
    getClientConfig(): RestResponse<ClientApplicationConfig> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`rest/properties` });
    }

    /**
     * HTTP GET /rest/properties/country
     * Java method: com.cubeia.nano.player.web.ConfigController.getCountryInfo
     */
    getCountryInfo(): RestResponse<CountryInfo> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`rest/properties/country` });
    }

    /**
     * HTTP GET /rest/properties/manifest
     * Java method: com.cubeia.nano.player.web.ConfigController.getManifest
     */
    getManifest(): RestResponse<string> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`rest/properties/manifest` });
    }

    /**
     * HTTP GET /rest/racebook/latrobet/launch-anonymous/{locale}
     * Java method: com.cubeia.nano.player.web.RacebookController.createAnonymousSportsbookUrl
     */
    createAnonymousSportsbookUrl$GET$rest_racebook_latrobet_launchanonymous_locale(locale: string): RestResponse<LaunchUrl> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`rest/racebook/latrobet/launch-anonymous/${locale}` });
    }

    /**
     * HTTP GET /rest/racebook/latrobet/launch/{currency}/{locale}
     * Java method: com.cubeia.nano.player.web.RacebookController.createSportsbookToken
     */
    createSportsbookToken$GET$rest_racebook_latrobet_launch_currency_locale(currency: string, locale: string): RestResponse<LaunchUrl> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`rest/racebook/latrobet/launch/${currency}/${locale}` });
    }

    /**
     * HTTP HEAD /rest/session/ping
     * Java method: com.cubeia.nano.player.web.SessionController.ping
     */
    ping(): RestResponse<void> {
        return this.httpClient.request({ method: "HEAD", url: uriEncoding`rest/session/ping` });
    }

    /**
     * HTTP GET /rest/settings
     * Java method: com.cubeia.nano.player.web.RootController.getSettings
     */
    getSettings(): RestResponse<Settings> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`rest/settings` });
    }

    /**
     * HTTP GET /rest/sitemap
     * Java method: com.cubeia.nano.player.web.SiteMapController.getSiteMap
     */
    getSiteMap(): RestResponse<SiteMapIndex> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`rest/sitemap` });
    }

    /**
     * HTTP GET /rest/sitemap/{page}
     * Java method: com.cubeia.nano.player.web.SiteMapController.getSiteMapPage
     */
    getSiteMapPage(page: number): RestResponse<SiteMap> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`rest/sitemap/${page}` });
    }

    /**
     * HTTP GET /rest/sportsbook/betby/launch-anonymous
     * Java method: com.cubeia.nano.player.web.BetbyController.createAnonymousSportsbookLaunchSettings
     */
    createAnonymousSportsbookLaunchSettings(): RestResponse<LaunchBetbyResponse> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`rest/sportsbook/betby/launch-anonymous` });
    }

    /**
     * HTTP GET /rest/sportsbook/betby/launch/{currency}/{locale}
     * Java method: com.cubeia.nano.player.web.BetbyController.createSportsbookLaunchSettings
     */
    createSportsbookLaunchSettings(currency: string, locale: string): RestResponse<LaunchBetbyResponse> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`rest/sportsbook/betby/launch/${currency}/${locale}` });
    }

    /**
     * HTTP GET /rest/sportsbook/saba/launch-anonymous/{locale}
     * Java method: com.cubeia.nano.player.web.SabaController.createAnonymousSportsbookUrl
     */
    createAnonymousSportsbookUrl$GET$rest_sportsbook_saba_launchanonymous_locale(locale: string, queryParams?: { platform?: SabaPlatform; }): RestResponse<LaunchUrl> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`rest/sportsbook/saba/launch-anonymous/${locale}`, queryParams: queryParams });
    }

    /**
     * HTTP GET /rest/sportsbook/saba/launch/{currency}/{locale}
     * Java method: com.cubeia.nano.player.web.SabaController.createSportsbookUrl
     */
    createSportsbookUrl(currency: string, locale: string, queryParams?: { platform?: SabaPlatform; }): RestResponse<LaunchUrl> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`rest/sportsbook/saba/launch/${currency}/${locale}`, queryParams: queryParams });
    }

    /**
     * HTTP GET /rest/sportsbook/song88/launch-anonymous/{currency}/{locale}
     * Java method: com.cubeia.nano.player.web.Song88Controller.createAnonymousSportsbookUrl
     */
    createAnonymousSportsbookUrl$GET$rest_sportsbook_song88_launchanonymous_currency_locale(currency: string, locale: string): RestResponse<LaunchUrl> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`rest/sportsbook/song88/launch-anonymous/${currency}/${locale}` });
    }

    /**
     * HTTP GET /rest/sportsbook/song88/launch/{currency}/{locale}
     * Java method: com.cubeia.nano.player.web.Song88Controller.createSportsbookToken
     */
    createSportsbookToken$GET$rest_sportsbook_song88_launch_currency_locale(currency: string, locale: string): RestResponse<LaunchUrl> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`rest/sportsbook/song88/launch/${currency}/${locale}` });
    }

    /**
     * HTTP GET /rest/sportsbook/ultraplay/launch-anonymous/{locale}
     * Java method: com.cubeia.nano.player.web.UltraplayController.createAnonymousSportsbookUrl
     */
    createAnonymousSportsbookUrl$GET$rest_sportsbook_ultraplay_launchanonymous_locale(locale: string, queryParams?: { mobile?: boolean; }): RestResponse<LaunchUrl> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`rest/sportsbook/ultraplay/launch-anonymous/${locale}`, queryParams: queryParams });
    }

    /**
     * HTTP GET /rest/sportsbook/ultraplay/launch/{currency}/{locale}
     * Java method: com.cubeia.nano.player.web.UltraplayController.createSportsbookToken
     */
    createSportsbookToken$GET$rest_sportsbook_ultraplay_launch_currency_locale(currency: string, locale: string, queryParams?: { mobile?: boolean; }): RestResponse<LaunchUrl> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`rest/sportsbook/ultraplay/launch/${currency}/${locale}`, queryParams: queryParams });
    }

    /**
     * HTTP GET /rest/store/bundle/all
     * Java method: com.cubeia.nano.player.web.BundleController.getAllActiveBundles
     */
    getAllActiveBundles(): RestResponse<ListBundlesResponse> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`rest/store/bundle/all` });
    }

    /**
     * HTTP GET /rest/store/bundle/bonus
     * Java method: com.cubeia.nano.player.web.BundleController.getAvailableBonusBundlesForUser
     */
    getAvailableBonusBundlesForUser(): RestResponse<ListBundlesResponse> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`rest/store/bundle/bonus` });
    }

    /**
     * HTTP GET /rest/store/bundle/bonus/claim/{bundleId}
     * Java method: com.cubeia.nano.player.web.BundleController.claimBonusBundlesForUser
     */
    claimBonusBundlesForUser(bundleId: number): RestResponse<void> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`rest/store/bundle/bonus/claim/${bundleId}` });
    }

    /**
     * HTTP POST /rest/store/bundle/buy/{bundleId}
     * Java method: com.cubeia.nano.player.web.BundleController.buyBundle
     */
    buyBundle(bundleId: number, request: BuyBundleRequest): RestResponse<PaymentDialog> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`rest/store/bundle/buy/${bundleId}`, data: request });
    }

    /**
     * HTTP GET /rest/store/bundle/id/{bundleId}
     * Java method: com.cubeia.nano.player.web.BundleController.getBundle
     */
    getBundle(bundleId: number): RestResponse<Bundle> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`rest/store/bundle/id/${bundleId}` });
    }

    /**
     * HTTP GET /rest/token
     * Java method: com.cubeia.nano.player.web.TokenController.root
     */
    root$GET$rest_token(): RestResponse<string> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`rest/token` });
    }

    /**
     * HTTP GET /rest/token/all
     * Java method: com.cubeia.nano.player.web.TokenController.getAllTokens
     */
    getAllTokens(queryParams?: { includeExpired?: boolean; }): RestResponse<AuthToken[]> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`rest/token/all`, queryParams: queryParams });
    }

    /**
     * HTTP GET /rest/token/all/clear
     * Java method: com.cubeia.nano.player.web.TokenController.clearAllTokens
     */
    clearAllTokens(): RestResponse<void> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`rest/token/all/clear` });
    }

    /**
     * HTTP GET /rest/token/count
     * Java method: com.cubeia.nano.player.web.TokenController.countAllTokens
     */
    countAllTokens(): RestResponse<number> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`rest/token/count` });
    }

    /**
     * HTTP GET /rest/token/token/delete/{id}
     * Java method: com.cubeia.nano.player.web.TokenController.deleteToken
     */
    deleteToken(id: number): RestResponse<void> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`rest/token/token/delete/${id}` });
    }

    /**
     * HTTP GET /rest/token/token/{id}
     * Java method: com.cubeia.nano.player.web.TokenController.getTokenByRefId
     */
    getTokenByRefId(id: number): RestResponse<AuthToken> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`rest/token/token/${id}` });
    }

    /**
     * HTTP POST /rest/transaction/list
     * Java method: com.cubeia.nano.player.web.PlayerTransactionController.listTransactions
     */
    listTransactions(trans: PlayerTransactionsRequest): RestResponse<PlayerTransactionsResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`rest/transaction/list`, data: trans });
    }

    /**
     * HTTP POST /rest/transaction/transfer-to-player
     * Java method: com.cubeia.nano.player.web.PlayerTransactionController.transferToPlayer
     */
    transferToPlayer(request: PlayerToPlayerTransferRequest): RestResponse<void> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`rest/transaction/transfer-to-player`, data: request });
    }

    /**
     * HTTP GET /rest/translations/{locale}
     * Java method: com.cubeia.nano.player.web.TranslationsController.getTranslations
     */
    getTranslations(locale: string): RestResponse<any> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`rest/translations/${locale}` });
    }

    /**
     * HTTP GET /rest/up
     * Java method: com.cubeia.nano.player.web.RootController.checkIfUp
     */
    checkIfUp(): RestResponse<void> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`rest/up` });
    }

    /**
     * HTTP GET /rest/user
     * Java method: com.cubeia.nano.player.web.UserController.root
     */
    root$GET$rest_user(): RestResponse<string> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`rest/user` });
    }

    /**
     * HTTP POST /rest/user-game-reward/claim/{userGameRewardId}
     * Java method: com.cubeia.nano.player.web.reward.UserGameRewardRestController.claimReward
     */
    claimReward(userGameRewardId: number): RestResponse<void> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`rest/user-game-reward/claim/${userGameRewardId}` });
    }

    /**
     * HTTP POST /rest/user-game-reward/list
     * Java method: com.cubeia.nano.player.web.reward.UserGameRewardRestController.list
     */
    list(listUserGameRewardRequest: ListUserGameRewardRequest): RestResponse<UserGameRewardQueryResult> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`rest/user-game-reward/list`, data: listUserGameRewardRequest });
    }

    /**
     * HTTP PUT /rest/user-game-reward/mark-all-as-read
     * Java method: com.cubeia.nano.player.web.reward.UserGameRewardRestController.markAllAsRead
     */
    markAllAsRead(): RestResponse<void> {
        return this.httpClient.request({ method: "PUT", url: uriEncoding`rest/user-game-reward/mark-all-as-read` });
    }

    /**
     * HTTP PUT /rest/user-game-reward/mark-as-read/{userGameRewardId}
     * Java method: com.cubeia.nano.player.web.reward.UserGameRewardRestController.markAsRead
     */
    markAsRead(userGameRewardId: number): RestResponse<void> {
        return this.httpClient.request({ method: "PUT", url: uriEncoding`rest/user-game-reward/mark-as-read/${userGameRewardId}` });
    }

    /**
     * HTTP GET /rest/user-game-reward/stream
     * Java method: com.cubeia.nano.player.stream.RewardStreamController.stream
     */
    stream(): RestResponse<any> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`rest/user-game-reward/stream` });
    }

    /**
     * HTTP GET /rest/user/account-balances
     * Java method: com.cubeia.nano.player.web.UserController.getUserBalances
     */
    getUserBalances(): RestResponse<AccountBalance[]> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`rest/user/account-balances` });
    }

    /**
     * HTTP POST /rest/user/account-balances-and-bonuses
     * Java method: com.cubeia.nano.player.web.UserController.getUserBalancesAndBonuses
     */
    getUserBalancesAndBonuses(requestDto: BalanceAndBonusRequest): RestResponse<BalanceAndBonus> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`rest/user/account-balances-and-bonuses`, data: requestDto });
    }

    /**
     * HTTP GET /rest/user/affiliate/{tracker}
     * Java method: com.cubeia.nano.player.web.UserController.affiliateTrackerClicked
     */
    affiliateTrackerClicked(tracker: string): RestResponse<void> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`rest/user/affiliate/${tracker}` });
    }

    /**
     * HTTP GET /rest/user/appcontext
     * Java method: com.cubeia.nano.player.web.UserController.getUserAppContext
     */
    getUserAppContext(): RestResponse<AppContext> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`rest/user/appcontext` });
    }

    /**
     * HTTP GET /rest/user/appcontext/plain
     * Java method: com.cubeia.nano.player.web.UserController.getUserAppContextString
     */
    getUserAppContextString(): RestResponse<string> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`rest/user/appcontext/plain` });
    }

    /**
     * HTTP POST /rest/user/authenticate
     * Java method: com.cubeia.nano.player.web.UserController.login
     */
    login(loginRequest: ManualLoginRequest): RestResponse<LoginResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`rest/user/authenticate`, data: loginRequest });
    }

    /**
     * HTTP POST /rest/user/authenticate/glife
     * Java method: com.cubeia.nano.player.web.UserController.loginWithGlife
     */
    loginWithGlife(loginRequest: GLifeLoginRequest): RestResponse<UserInfo> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`rest/user/authenticate/glife`, data: loginRequest });
    }

    /**
     * HTTP POST /rest/user/authenticate/glife/deferred
     * Java method: com.cubeia.nano.player.web.UserController.loginWithGlifeDeferred
     */
    loginWithGlifeDeferred(loginRequest: GlifeDeferredSignupLoginRequest): RestResponse<UserInfo> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`rest/user/authenticate/glife/deferred`, data: loginRequest });
    }

    /**
     * HTTP POST /rest/user/authenticate/glife/one-time-token
     * Java method: com.cubeia.nano.player.web.UserController.loginUsingGlifeOneTimeToken
     */
    loginUsingGlifeOneTimeToken(loginRequest: TokenLoginRequest): RestResponse<UserInfo> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`rest/user/authenticate/glife/one-time-token`, data: loginRequest });
    }

    /**
     * HTTP POST /rest/user/authenticate/mayaminiapp
     * Java method: com.cubeia.nano.player.web.UserController.loginWithMayaMiniApp
     */
    loginWithMayaMiniApp(loginRequest: MayaMiniAppLoginRequest): RestResponse<UserInfo> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`rest/user/authenticate/mayaminiapp`, data: loginRequest });
    }

    /**
     * HTTP POST /rest/user/authenticate/sso
     * Java method: com.cubeia.nano.player.web.SsoUserController.loginWithIdp
     */
    loginWithIdp(ssoLoginRequest: SSOLoginRequest): RestResponse<any> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`rest/user/authenticate/sso`, data: ssoLoginRequest });
    }

    /**
     * HTTP POST /rest/user/authenticate/token
     * Java method: com.cubeia.nano.player.web.UserController.loginWithToken
     */
    loginWithToken(loginRequest: TokenLoginRequest): RestResponse<LoginResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`rest/user/authenticate/token`, data: loginRequest });
    }

    /**
     * HTTP POST /rest/user/cashback/claim/{configId}
     * Java method: com.cubeia.nano.player.web.CashbackController.claim
     */
    claim(configId: number): RestResponse<ClaimResult> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`rest/user/cashback/claim/${configId}` });
    }

    /**
     * HTTP GET /rest/user/cashback/next-upcoming
     * Java method: com.cubeia.nano.player.web.CashbackController.getNextUpcoming
     */
    getNextUpcoming(): RestResponse<UpcomingCashback[]> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`rest/user/cashback/next-upcoming` });
    }

    /**
     * HTTP POST /rest/user/create-account
     * Java method: com.cubeia.nano.player.web.UserController.register
     */
    register(registration: RegistrationRequest): RestResponse<RegistrationResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`rest/user/create-account`, data: registration });
    }

    /**
     * HTTP GET /rest/user/details
     * Java method: com.cubeia.nano.player.web.UserController.getUserInfo
     */
    getUserInfo(): RestResponse<UserInfo> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`rest/user/details` });
    }

    /**
     * HTTP GET /rest/user/glife/one-time-token
     * Java method: com.cubeia.nano.player.web.UserController.createOneTimeAuthToken
     */
    createOneTimeAuthToken(): RestResponse<OneTimeTokenResponse> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`rest/user/glife/one-time-token` });
    }

    /**
     * HTTP GET /rest/user/kyc-started
     * Java method: com.cubeia.nano.player.web.UserController.setKycStarted
     */
    setKycStarted(): RestResponse<void> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`rest/user/kyc-started` });
    }

    /**
     * HTTP GET /rest/user/level
     * Java method: com.cubeia.nano.player.web.UserController.getUserLevel
     */
    getUserLevel(): RestResponse<UserLevelView> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`rest/user/level` });
    }

    /**
     * HTTP POST /rest/user/locale/{locale}
     * Java method: com.cubeia.nano.player.web.UserController.setUserLanguage
     */
    setUserLanguage(locale: string): RestResponse<void> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`rest/user/locale/${locale}` });
    }

    /**
     * HTTP GET /rest/user/logout
     * Java method: com.cubeia.nano.player.web.UserController.logout
     */
    logout(): RestResponse<void> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`rest/user/logout` });
    }

    /**
     * HTTP GET /rest/user/me
     * Java method: com.cubeia.nano.player.web.UserController.getCurrentUser
     */
    getCurrentUser(): RestResponse<ResolvedUid> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`rest/user/me` });
    }

    /**
     * HTTP POST /rest/user/mfa/enable
     * Java method: com.cubeia.nano.player.web.UserController.getMultiFactorAuthentication
     */
    getMultiFactorAuthentication(request: MultiFactorAuthRequest): RestResponse<MultiFactorAuthResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`rest/user/mfa/enable`, data: request });
    }

    /**
     * HTTP POST /rest/user/mfa/verify
     * Java method: com.cubeia.nano.player.web.UserController.verifyMultiFactorAuthentication
     */
    verifyMultiFactorAuthentication(request: MultiFactorAuthRequest): RestResponse<void> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`rest/user/mfa/verify`, data: request });
    }

    /**
     * HTTP GET /rest/user/password/policy
     * Java method: com.cubeia.nano.player.web.UserController.getPasswordPolicy
     */
    getPasswordPolicy(): RestResponse<PasswordPolicyDescriptor> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`rest/user/password/policy` });
    }

    /**
     * HTTP POST /rest/user/password/reset
     * Java method: com.cubeia.nano.player.web.UserController.resetPassword
     */
    resetPassword(request: ResetPasswordRequest): RestResponse<PasswordResetResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`rest/user/password/reset`, data: request });
    }

    /**
     * HTTP POST /rest/user/password/validate
     * Java method: com.cubeia.nano.player.web.UserController.validatePassword
     */
    validatePassword(request: PasswordValidationRequest): RestResponse<PasswordValidationResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`rest/user/password/validate`, data: request });
    }

    /**
     * HTTP GET /rest/user/profile-visibility
     * Java method: com.cubeia.nano.player.web.UserController.getProfileVisibility
     */
    getProfileVisibility(): RestResponse<ProfileVisibility> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`rest/user/profile-visibility` });
    }

    /**
     * HTTP PUT /rest/user/profile-visibility
     * Java method: com.cubeia.nano.player.web.UserController.updateProfileVisibility
     */
    updateProfileVisibility(visibility: ProfileVisibility): RestResponse<ProfileVisibility> {
        return this.httpClient.request({ method: "PUT", url: uriEncoding`rest/user/profile-visibility`, data: visibility });
    }

    /**
     * HTTP GET /rest/user/public-profile/{userUid}
     * Java method: com.cubeia.nano.player.web.UserController.getPlayerProfile
     */
    getPlayerProfile(userUid: string, queryParams?: { periodDays?: number; previewMode?: boolean; }): RestResponse<PlayerProfile> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`rest/user/public-profile/${userUid}`, queryParams: queryParams });
    }

    /**
     * HTTP GET /rest/user/public-upcoming-cashbacks
     * Java method: com.cubeia.nano.player.web.UserController.getUpcomingCashback
     */
    getUpcomingCashback(): RestResponse<NextUpcomingCashback[]> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`rest/user/public-upcoming-cashbacks` });
    }

    /**
     * HTTP GET /rest/user/recover-password/email/{email}
     * Java method: com.cubeia.nano.player.web.UserController.forgotPasswordByEmail
     */
    forgotPasswordByEmail(email: string): RestResponse<void> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`rest/user/recover-password/email/${email}` });
    }

    /**
     * HTTP GET /rest/user/recover-password/sms/{phone}
     * Java method: com.cubeia.nano.player.web.UserController.forgotPasswordBySms
     */
    forgotPasswordBySms(phone: string): RestResponse<void> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`rest/user/recover-password/sms/${phone}` });
    }

    /**
     * HTTP GET /rest/user/referral/{invitation}
     * Java method: com.cubeia.nano.player.web.UserController.invitationTrackerClicked
     */
    invitationTrackerClicked(invitation: string): RestResponse<void> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`rest/user/referral/${invitation}` });
    }

    /**
     * HTTP GET /rest/user/referrals
     * Java method: com.cubeia.nano.player.web.UserController.getDetailedInvitation
     */
    getDetailedInvitation(): RestResponse<DetailedInvitation> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`rest/user/referrals` });
    }

    /**
     * HTTP GET /rest/user/referrals/max-invitation
     * Java method: com.cubeia.nano.player.web.UserController.getInvitationMaxLimitPerUser
     */
    getInvitationMaxLimitPerUser(): RestResponse<InvitationMaxLimit> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`rest/user/referrals/max-invitation` });
    }

    /**
     * HTTP POST /rest/user/refresh
     * Java method: com.cubeia.nano.player.web.RefreshController.refresh
     */
    refresh(): RestResponse<AccessTokenResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`rest/user/refresh` });
    }

    /**
     * HTTP POST /rest/user/request-principal-verification
     * Java method: com.cubeia.nano.player.web.UserController.requestPrincipalVerification
     */
    requestPrincipalVerification(request: RequestPrincipalVerification): RestResponse<void> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`rest/user/request-principal-verification`, data: request });
    }

    /**
     * HTTP GET /rest/user/settings
     * Java method: com.cubeia.nano.player.web.UserController.getUserSettings
     */
    getUserSettings(): RestResponse<{ [index: string]: string }> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`rest/user/settings` });
    }

    /**
     * HTTP GET /rest/user/settings/{key}
     * Java method: com.cubeia.nano.player.web.UserController.getUserSetting
     */
    getUserSetting(key: string): RestResponse<string> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`rest/user/settings/${key}` });
    }

    /**
     * HTTP PUT /rest/user/settings/{key}/{value}
     * Java method: com.cubeia.nano.player.web.UserController.setUserSetting
     */
    setUserSetting(key: string, value: string): RestResponse<void> {
        return this.httpClient.request({ method: "PUT", url: uriEncoding`rest/user/settings/${key}/${value}` });
    }

    /**
     * HTTP GET /rest/user/sso/list
     * Java method: com.cubeia.nano.player.web.SsoUserController.ssoList
     */
    ssoList(): RestResponse<IdpLoginParameters[]> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`rest/user/sso/list` });
    }

    /**
     * HTTP GET /rest/user/sso/one-tap/nonce
     * Java method: com.cubeia.nano.player.web.SsoUserController.googleOneTapNonce
     */
    googleOneTapNonce(): RestResponse<GoogleOneTapNonce> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`rest/user/sso/one-tap/nonce` });
    }

    /**
     * HTTP GET /rest/user/sso/{idp}/login
     * Java method: com.cubeia.nano.player.web.SsoUserController.preSsoLogin
     */
    preSsoLogin(idp: LoginType): RestResponse<any> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`rest/user/sso/${idp}/login` });
    }

    /**
     * HTTP POST /rest/user/test-widget-authentication
     * Java method: com.cubeia.nano.player.web.UserController.testAuth
     */
    testAuth(req: WidgetAuthRequest): RestResponse<WidgetAuthResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`rest/user/test-widget-authentication`, data: req });
    }

    /**
     * HTTP GET /rest/user/upcoming-cashback-time
     * Java method: com.cubeia.nano.player.web.UserController.getUpcomingCashbackTime
     */
    getUpcomingCashbackTime(): RestResponse<NextUpcomingCashback[]> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`rest/user/upcoming-cashback-time` });
    }

    /**
     * HTTP GET /rest/user/upcoming-cashbacks
     * Java method: com.cubeia.nano.player.web.UserController.getUpcomingCashbackForUser
     */
    getUpcomingCashbackForUser(): RestResponse<NextUpcomingCashback[]> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`rest/user/upcoming-cashbacks` });
    }

    /**
     * HTTP POST /rest/user/update-attributes
     * Java method: com.cubeia.nano.player.web.UserController.updateUserAttributes
     */
    updateUserAttributes(attributes: { [index: string]: string }): RestResponse<UserInfo> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`rest/user/update-attributes`, data: attributes });
    }

    /**
     * HTTP POST /rest/user/update-settings
     * Java method: com.cubeia.nano.player.web.UserController.updateUserSettings
     */
    updateUserSettings(userSettings: { [index: string]: string }): RestResponse<UserInfo> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`rest/user/update-settings`, data: userSettings });
    }

    /**
     * HTTP GET /rest/user/user-journey
     * Java method: com.cubeia.nano.player.web.UserController.getUserJourney
     */
    getUserJourney(): RestResponse<UserJourneyAndAttributes> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`rest/user/user-journey` });
    }

    /**
     * HTTP GET /rest/user/verify/{userUid}/{code}/{link}
     * Java method: com.cubeia.nano.player.web.UserController.verifyChannelCode
     */
    verifyChannelCode(userUid: string, code: string, link: boolean): RestResponse<any> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`rest/user/verify/${userUid}/${code}/${link}` });
    }

    /**
     * HTTP GET /rest/user/widget-authentication
     * Java method: com.cubeia.nano.player.web.UserController.authenticateWidgets
     */
    authenticateWidgets(): RestResponse<WidgetAuthentication[]> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`rest/user/widget-authentication` });
    }

    /**
     * HTTP POST /rest/user/zendesk/jwt
     * Java method: com.cubeia.nano.player.web.ZendeskController.issueJwt
     */
    issueJwt(): RestResponse<ZendeskJwtResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`rest/user/zendesk/jwt` });
    }
}

export interface AccessTokenResponse {
    accessToken?: string;
    reason?: string;
}

export interface AccountBalance {
    balance?: Money;
    reservedBonus?: Money;
    role?: AccountRole;
}

export interface AppIntegrationLoginRequest extends LoginRequest {
    appContext?: AppContext;
    deferredSignupEnabled?: boolean;
}

export interface AuthToken {
    device?: string;
    hasExpired?: boolean;
    id?: number;
}

export interface BalanceAndBonus {
    accountBalanceList?: AccountBalance[];
    activeBonusList?: UserBonusView[];
    activeOfferList?: BonusOffer[];
    currencyDefinitionList?: CurrencyDefinition[];
    messages?: ListUserMessageResponse;
}

export interface BalanceAndBonusRequest {
    currencies?: string[];
    skipBalance?: boolean;
}

export interface BankInfo {
    accountAddress1?: string;
    accountAddress2?: string;
    accountCity?: string;
    accountCountry?: string;
    accountNumber?: string;
    accountOwner?: string;
    accountState?: string;
    accountZip?: string;
    name?: string;
    routingNumber?: string;
}

export interface BankTransferContext {
    bankAccountNumber?: string;
    bankAccountOwner?: string;
    bankName?: string;
    bankRoutingNumber?: string;
}

export interface BonusConfig {
    blockUponOtherClaims?: boolean;
    bonusAlertDescription?: string;
    bonusStatusAlert?: BonusStatusAlert;
    description?: string;
    expiresAfterDays?: number;
    hasOfferedBonus?: boolean;
    id?: number;
    imageUrl?: string;
    monetaryConfig?: MonetaryConfig;
    name?: string;
    status?: BonusStatus;
    summary?: string;
    translations?: BonusConfigTranslation[];
    trigger?: BonusTrigger;
    turnoverContributions?: TurnoverContributions;
    type?: BonusLogicType;
    validFromDate?: Date;
    validToDate?: Date;
}

export interface BonusConfigTranslation {
    description?: string;
    id?: number;
    imageUrl?: string;
    language?: string;
    name?: string;
    summary?: string;
}

export interface BonusContext {
    blockedFromPlaying?: boolean;
    contributionFactor?: number;
    maxWager?: number;
}

export interface BonusOffer {
    amount?: number;
    bonusConfig?: BonusConfig;
    currency?: string;
    depositRewardConfigId?: number;
    depositRewardConfigImageUrl?: string;
    depositRewardConfigName?: string;
    depositRewardDescription?: string;
    depositRewardType?: DepositRewardType;
    expires?: Date;
    freeSpinsCount?: number;
    gameId?: number;
    gameName?: string;
    id?: number;
    inputAmount?: number;
    perSpinBet?: number;
    status?: BonusOfferStatus;
    timestamp?: Date;
    turnoverRequirement?: number;
    userId?: number;
}

export interface BonusSportsbookInfo {
    activeBonus?: boolean;
    activeSportsbookBonus?: boolean;
    contributions?: Contribution[];
}

export interface BonusTrigger {
    count?: number;
    event?: string;
    expiresAfterDays?: number;
    id?: number;
    name?: string;
    triggerType?: RuleTriggerType;
}

export interface BonusUpcomingOffer {
    award?: boolean;
    bonusConfig?: BonusConfig;
    expiry?: Date;
}

export interface Bundle {
    awardFunds1?: Monetary;
    awardFunds2?: Monetary;
    awardPokerItemId?: string;
    awardPokerItemList?: PokerItem[];
    created?: Date;
    description?: string;
    enabled?: boolean;
    featured?: boolean;
    id?: number;
    imageUrl?: string;
    label?: string;
    name?: string;
    nameId?: string;
    price?: Monetary;
    type?: BundleType;
}

export interface BuyBundleRequest {
    method?: string;
    provider?: string;
}

export interface CasinoAdminLocaleSeo {
    canonicalOverrides?: CasinoCanonicalOverrides;
    categories?: { [index: string]: SeoMetadata };
    tabs?: { [index: string]: SeoMetadata };
}

export interface CasinoCanonicalOverrides {
    categories?: { [index: string]: { [index: string]: string } };
    tabs?: { [index: string]: { [index: string]: string } };
}

export interface CasinoCurrencies {
    currencies?: string[];
    integration?: GameIntegration;
    studio?: number;
    studioId?: number;
}

export interface CasinoGameInfo {
    allowedCountries?: string;
    aspectRatio?: CasinoGameAspectRatio;
    backgroundImageUrl?: string;
    blockedCountries?: string;
    description?: string;
    desktop?: boolean;
    display?: GameDisplay;
    externalId?: string;
    gameTags?: number[];
    gameType?: CasinoGameType;
    id?: number;
    imageUrl?: string;
    imageVariants?: string[];
    integration?: GameIntegration;
    jurisdictions?: number[];
    mobile?: boolean;
    mobileExternalId?: string;
    name?: string;
    playForFun?: boolean;
    promoImageUrl?: string;
    releaseDate?: Date;
    studioId?: number;
    translations?: CasinoGameTranslation[];
}

export interface CasinoGameLocaleSeo {
    canonicalOverrides?: { [index: string]: string };
    canonicalUrl?: string;
    description?: string;
    keywords?: string;
    locale?: string;
    ogImageUrl?: string;
    title?: string;
}

export interface CasinoGameTranslation {
    description?: string;
    id?: number;
    imageUrl?: string;
    language?: string;
    name?: string;
}

export interface CasinoLobby {
    currencies?: CasinoCurrencies[];
    games?: CasinoGameInfo[];
    images?: CentralImagesConfig;
    jurisdictions?: Jurisdiction[];
    pages?: CasinoPage[];
    studios?: CasinoStudio[];
    tags?: GameTag[];
}

export interface CasinoLobbyCategory {
    alwaysRenderVertically?: boolean;
    categoryType?: CasinoLobbyCategoryType;
    contentKey?: string;
    gameOrder?: GameOrder;
    gameTypes?: CasinoGameType[];
    games?: number[];
    id?: number;
    imgVariant?: Style;
    itemView?: number;
    lobbyOrder?: number;
    matchAllSelectedTags?: boolean;
    maxNrOfGames?: number;
    name?: string;
    studioIds?: number[];
    studios?: number[];
    surpriseEnabled?: boolean;
    tags?: number[];
    translationKey?: string;
    translations?: { [index: string]: string };
}

export interface CasinoPage {
    defaultPage?: boolean;
    gameTags?: number[];
    games?: number[];
    hideCountryRestrictedGames?: boolean;
    id?: number;
    name?: string;
    singleTab?: CasinoPageTab;
    studios?: number[];
    tabs?: CasinoPageTab[];
}

export interface CasinoPageTab {
    categories?: CasinoLobbyCategory[];
    id?: number;
    name?: string;
    translations?: { [index: string]: string };
}

export interface CasinoSortedLobby {
    currencies?: CasinoCurrencies[];
    games?: { [index: string]: CasinoGameInfo };
    images?: CentralImagesConfig;
    jurisdictions?: Jurisdiction[];
    pages?: CasinoPage[];
    singlePage?: CasinoPage;
    studios?: { [index: string]: CasinoStudio };
    tags?: { [index: string]: GameTag };
}

export interface CasinoStudio {
    allowedCountries?: string;
    blockedCountries?: string;
    blockedCurrencies?: string;
    enabled?: boolean;
    externalId?: string;
    gameTags?: string;
    gameTagsToBeAdded?: string;
    gameTagsToBeRemoved?: string;
    icon?: string;
    id?: number;
    imageUrl?: string;
    integration?: GameIntegration;
    lobbyOrder?: number;
    name?: string;
    popular?: boolean;
    promoImageUrl?: string;
    providerBlockedCountries?: string;
}

export interface CentralImagesConfig {
    enabled?: boolean;
    game?: Games;
    integrations?: Integrations;
    provider?: Provider;
}

export interface ClaimResult {
    amount?: number;
    currency?: string;
    message?: string;
    success?: boolean;
}

export interface ClientApplicationConfig {
    clientBaseUrl?: string;
    facebookAppId?: string;
    googleAnalyticsId?: string;
    googleTagManagerId?: string;
    manifest?: string;
    operatorId?: string;
}

export interface CompositionRules {
    lowercase?: boolean;
    number?: boolean;
    special?: boolean;
    uppercase?: boolean;
}

export interface Config {
    /**
     * The parameter defines the gap between window bottom and betslip (for example, fixed footer).
     */
    betSlipOffsetBottom?: number;
    /**
     * The parameter defines the gap between window bottom and betslip (for example, fixed footer).
     */
    betSlipOffsetBottomMobile?: number;
    /**
     * The parameter defines the gap between window right side and betslip (for example, fixed sidebar).
     */
    betSlipOffsetRight?: number;
    /**
     * The parameter defines the gap between window right side and betslip (for example, fixed sidebar).
     */
    betSlipOffsetRightMobile?: number;
    /**
     * The parameter defines the gap between window top and opened betslip (for example, fixed header).
     */
    betSlipOffsetTop?: number;
    /**
     * The parameter defines the gap between window top and opened betslip (for example, fixed header).
     */
    betSlipOffsetTopMobile?: number;
    /**
     * The parameter defines the index of betslip in relation to DOM elements used on Partners website. It helps to avoid overlapping conflicts of different elements. Value should be 100 or more.
     */
    betslipZIndex?: number;
    /**
     * The parameter defines the index of betslip in relation to DOM elements used on Partners website. It helps to avoid overlapping conflicts of different elements. Value should be 100 or more.
     */
    betslipZIndexMobile?: number;
    /**
     * Operator brand id
     */
    brand_id?: string;
    /**
     * Default currency
     */
    currency?: string;
    /**
     * Betby bt-renderer script URL for this line. Leave unset to fall back to the operator-wide customScripts entry.
     */
    scriptUrl?: string;
    /**
     * The height value of fixed header
     */
    stickyTop?: number;
    /**
     * The height value of fixed header
     */
    stickyTopMobile?: number;
    /**
     * Theme name for custom css override
     */
    themeName?: string;
}

export interface Contribution {
    contributionFactor?: number;
    description?: string;
    excludeCasinoTags?: string;
    id?: number;
    includeCasinoTags?: string;
    liveBetting?: boolean;
    maxOdds?: number;
    minOdds?: number;
    preMatchBetting?: boolean;
    product?: ContributionProduct;
    translations?: ContributionTranslation[];
}

export interface ContributionTranslation {
    description?: string;
    id?: number;
    language?: string;
}

export interface Country {
    alpha2?: string;
    alpha3?: string;
    callingCode?: number;
    translations?: { [index: string]: string };
}

export interface CountryInfo {
    blocked?: boolean;
    countryCode?: string;
    countryName?: string;
    jurisdiction?: Jurisdiction;
}

export interface CryptoExchangeRate {
    currencyDefinition?: CurrencyDefinition;
    rate?: number;
}

export interface CryptoNetwork {
    amountRequired?: boolean;
    code?: string;
    displayName?: string;
}

export interface CryptoWithdrawContext {
    coin?: string;
    coinName?: string;
    fees?: CryptoWithdrawFees;
    network?: string;
    networkName?: string;
    token?: string;
}

export interface CryptoWithdrawFees {
    currency?: string;
    priority?: NetworkPriority;
    withdrawFee?: number;
}

export interface Currency {
    code?: string;
    cryptoCurrency?: boolean;
    cryptoExchangeEnabled?: boolean;
    eurExchangeRate?: number;
    fractionalDigits?: number;
    irlCurrencyCode?: string;
    irlCurrencyFactor?: number;
    name?: string;
    postfixSymbol?: string;
    prefixSymbol?: string;
    visible?: boolean;
}

export interface CurrencyDefinition {
    code?: string;
    cryptoCurrency?: boolean;
    cryptoPrices?: { [index: string]: CryptoExchangeRate };
    fractionalDigits?: number;
    irlCurrencyCode?: string;
    irlCurrencyFactor?: number;
    name?: string;
    postfixSymbol?: string;
    prefixSymbol?: string;
    visible?: boolean;
}

export interface CustomerInfo {
    address?: string;
    bank?: BankInfo;
    context?: any;
    countryCode?: string;
    dateOfBirth?: Date;
    email?: string;
    firstName?: string;
    ipAddress?: string;
    languageCode?: string;
    lastName?: string;
    mobileNumber?: string;
    nickname?: string;
    paymentPermitted?: PaymentPermitted;
    personId?: string;
    phone?: string;
    state?: string;
    userId?: number;
    userUid?: string;
}

export interface DepositContext {
    defaultDepositAmount?: number;
    firstTimeDepositLimit?: number;
    isFirstTimeDeposit?: boolean;
    kycRequired?: boolean;
    maxDeposit?: number;
    minDeposit?: number;
    providerProperties?: { [index: string]: string };
}

export interface DepositResult {
    message?: string;
    paymentId?: number;
    paymentUid?: string;
    referenceId?: string;
    result?: DepositResultCode;
}

export interface DepositRewardConfig {
    autoClaim?: boolean;
    currencyCode?: string;
    depositPercentage?: number;
    description?: string;
    expiresAfterDays?: number;
    gameId?: number;
    gameName?: string;
    id?: number;
    imageUrl?: string;
    maxRewardAmount?: number;
    minDepositAmount?: number;
    name?: string;
    rewardTemplateId?: number;
    rewardType?: DepositRewardType;
    status?: BonusStatus;
    trigger?: BonusTrigger;
    useTemplateDefaults?: boolean;
    validFromDate?: Date;
    validToDate?: Date;
}

export interface DetailedInvitation {
    invitations?: Invitations;
    inviterDetails?: InviterDetails;
}

export interface EnforcedGameStyle {
    height?: number;
    style?: Style;
    width?: number;
}

export interface Exchange {
    local?: ExchangeCurrency;
    provider?: ExchangeCurrency;
}

export interface ExchangeCurrency {
    code?: string;
    name?: string;
}

export interface FallbackImages {
    landscape?: string;
    portrait?: string;
}

export interface FormStep {
    groups?: UserInputGroup[];
}

/**
 * Freshchat Configuration
 */
export interface FreshchatConfig {
    headerProperty?: HeaderProperty;
}

export interface GLifeLoginRequest extends TradableLoginRequest {
    authCode?: string;
    authCodePayload?: GlifeAuthCodePayload;
}

export interface GameTag {
    display?: boolean;
    id?: number;
    name?: string;
    nameId?: string;
    translations?: { [index: string]: string };
}

export interface Games {
    "default-style"?: Style;
    enforcedStyle?: EnforcedGameStyle;
    "fallback-images"?: FallbackImages;
    "style-sizes"?: { [P in Style]?: StyleSize };
    styles?: { [P in Style]?: string };
}

export interface GenericListResponse<T> {
    paged?: boolean;
}

export interface GenericUnPagedListResponse<T> extends GenericListResponse<T> {
    items?: T[];
}

export interface GlifeAuthCodePayload {
    authCode?: string;
    authErrorScopes?: { [index: string]: string };
    authSuccessScopes?: string[];
}

export interface GlifeDeferredSignupLoginRequest extends AppIntegrationLoginRequest {
}

export interface GoogleOneTapFrontendSettings {
    clientId?: string;
    enabled?: boolean;
}

export interface GoogleOneTapNonce {
    nonce?: string;
}

export interface HeaderProperty {
    /**
     * Logo Url
     */
    appLogo?: string;
    /**
     * Application Name
     */
    appName?: string;
    /**
     * Background Color in CSS syntax: #123456
     */
    backgroundColor?: string;
    /**
     * Background Image Url
     */
    backgroundImage?: string;
    /**
     * Foreground Color in CSS syntax: #123456
     */
    foregroundColor?: string;
}

export interface IdpLoginParameters {
    loginData?: { [index: string]: string };
    loginType?: LoginType;
}

export interface IndexSiteMap {
    loc?: string;
}

export interface Integrations {
    completed?: string[];
    studios?: { [index: string]: string[] };
}

export interface InvitationMaxLimit {
    invitationMaxLimitPerUser?: number;
}

export interface Invitations {
    completed?: Progress[];
    inProgress?: Progress[];
}

export interface InviterDetails {
    progress?: Progress;
    rewardStats?: RewardStats;
}

export interface Jackpot {
    externalId?: string;
    games?: JackpotGame[];
    integration?: GameIntegration;
    name?: string;
    pools?: JackpotPool[];
}

export interface JackpotBalance {
    amount?: number;
    currencyCode?: string;
}

export interface JackpotGame {
    externalId?: string;
    id?: number;
    name?: string;
}

export interface JackpotList {
    jackpots?: Jackpot[];
}

export interface JackpotPool {
    pool?: JackpotBalance[];
    type?: string;
}

export interface Jurisdiction {
    allowedCountries?: string[];
    blockedCountries?: string[];
    id?: number;
    name?: JurisdictionName;
}

export interface LaunchBetbyResponse {
    config?: Config;
    kycRequired?: boolean;
    proxyUrl?: string;
    token?: string;
}

export interface LaunchCasinoGameResponse {
    bonusContext?: BonusContext;
    country?: string;
    exchange?: Exchange;
    lineName?: string;
    originals?: boolean;
    primary?: boolean;
    provider?: string;
    reason?: LaunchBlockReason;
    status?: LaunchStatus;
    url?: string;
    userLimit?: number;
}

export interface LaunchUrl {
    blockedDueToActiveBonus?: boolean;
    blockedDueToKyc?: boolean;
    token?: string;
    url?: string;
}

export interface ListBundlesResponse extends ListResponse {
    items?: Bundle[];
}

export interface ListMinimalUserMessageProjectionResponse {
    messages?: UserMessageMinimalProjection[];
    unreadMessages?: number;
}

export interface ListRequest extends UnorderedListRequest {
    ascending?: boolean;
    orderBy?: string;
}

export interface ListResponse {
    nrOfResults?: number;
}

export interface ListSessionUserPaymentsRequest {
    currency?: string;
    listRequest?: UnorderedListRequest;
    statuses?: PaymentStatus[];
    type?: PaymentType;
}

export interface ListUserGameRewardRequest extends ListRequest {
    excludeExpired?: boolean;
    id?: number;
    removed?: boolean;
    status?: RewardStatus;
    userId?: number;
}

export interface ListUserMessageRequest extends ListRequest {
    userId?: number;
}

export interface ListUserMessageResponse {
    messages?: UserMessage[];
    unreadMessages?: number;
}

export interface LoginRequest {
    appMode?: AppMode;
    device?: string;
    deviceId?: string;
    generateLoginToken?: boolean;
    mfaProvider?: MultiFactorAuthProvider;
    mfaVerificationCode?: number;
    termsVersionToAccept?: string;
    visitorId?: string;
}

export interface LoginResponse {
    accessToken?: string;
    user?: UserInfo;
}

export interface MaintenanceAndServerTime {
    maintenanceWindow?: MaintenanceWindow;
    productMaintenance?: MaintenanceWindow[];
    serverTime?: Date;
}

export interface MaintenanceWindow {
    announceBeforeStart?: Date;
    category?: MaintenanceCategory;
    enabled?: boolean;
    id?: number;
    start?: Date;
}

export interface ManualLoginRequest extends LoginRequest {
    email?: string;
    password?: string;
    phoneNumber?: string;
    verification?: LoginVerification;
}

export interface MayaMiniAppLoginRequest extends TradableLoginRequest {
    sessionId?: string;
}

export interface Menu {
    footerItems?: MenuItem[];
    items?: MenuItem[];
    settings?: MenuSettings;
}

export interface MenuComponent {
    loggedInComponent?: MenuComponentType;
    loggedOutComponent?: MenuComponentType;
}

export interface MenuItem {
    disableSidebarCollapse?: boolean;
    downloadAppLink?: boolean;
    excludeCountries?: string;
    expandSubmenuOnly?: boolean;
    icon?: string;
    includeCountries?: string;
    includeInDesktopMenu?: boolean;
    includeInMobileMenu?: boolean;
    includeInSidebarMenu?: boolean;
    name?: string;
    subMenu?: SubMenu;
    supportLink?: boolean;
    target?: string;
    translations?: { [index: string]: string };
    type?: MenuItemType;
    url?: string;
}

export interface MenuSettings {
    enabeLogoSideMenu?: boolean;
    enableLogoTopMenu?: boolean;
    iconPack?: string;
    menuComponents?: MenuComponent;
    partialCollapsed?: boolean;
    position?: MenuPosition;
}

export interface Monetary {
    amount?: number;
    currency?: string;
}

export interface MonetaryConfig {
    awardAmountFraction?: number;
    awardType?: AwardType;
    bonusPaymentType?: BonusPaymentType;
    bustThreshold?: number;
    cashRewardTemplateId?: number;
    currencyCode?: string;
    id?: number;
    inputAmountAsBonusMoney?: boolean;
    maxInputAmount?: number;
    maxWagerAmount?: number;
    minInputAmount?: number;
    name?: string;
    removed?: boolean;
    turnoverRequirementFactor?: number;
}

export interface Money {
    amount?: number;
    currencyCode?: string;
    fractionalDigits?: number;
}

export interface MultiFactorAuthRequest {
    provider?: MultiFactorAuthProvider;
    verificationCode?: number;
}

export interface MultiFactorAuthResponse {
    imageUrl?: string;
    issuer?: string;
    provider?: MultiFactorAuthProvider;
    secret?: string;
    timeToLiveSeconds?: number;
    username?: string;
}

export interface NetworkPriority {
    high?: number;
    low?: number;
    medium?: number;
}

export interface NextUpcomingCashback {
    amount?: number;
    calculationTime?: Date;
    configId?: number;
    configName?: string;
    currency?: string;
    frequency?: string;
    notEligibleReason?: NotEligibleReason;
    payoutOngoing?: boolean;
    scheduled?: Date;
}

export interface OneTimeTokenResponse {
    token?: string;
}

export interface OnramperLaunchResponse {
    openInNewWindow?: boolean;
    provider?: CryptoOnrampProvider;
    url?: string;
}

export interface Order {
    amount?: number;
    currencyCode?: string;
    custom?: any;
    customerInfo?: CustomerInfo;
    destinationTag?: string;
    failUrl?: string;
    method?: string;
    notes?: string;
    priority?: Priority;
    purchaseBundleId?: number;
    purchaseBundleName?: string;
    recipientAddress?: string;
    requestKyc?: boolean;
    reuseAddressIfPossible?: boolean;
    successUrl?: string;
    type?: PaymentType;
    uid?: string;
}

export interface PasswordPolicyDescriptor {
    composition?: CompositionRules;
    maxLength?: number;
    minLength?: number;
}

export interface PasswordResetResponse {
    code?: PasswordViolation;
}

export interface PasswordValidationRequest {
    password?: string;
}

export interface PasswordValidationResponse {
    valid?: boolean;
    violation?: PasswordViolation;
}

export interface Payment {
    address?: string;
    amount?: number;
    amountEuro?: number;
    attributes?: { [index: string]: string };
    cancellableByPlayer?: boolean;
    created?: Date;
    cryptoTxReference?: string;
    currency?: string;
    destinationTag?: string;
    externalPaymentId?: string;
    finalized?: boolean;
    id?: number;
    log?: PaymentLog[];
    order?: Order;
    paymentReverseTxId?: number;
    paymentTxId?: number;
    provider?: string;
    status?: PaymentStatus;
    type?: PaymentType;
    uid?: string;
    updated?: Date;
    userId?: number;
}

export interface PaymentDialog {
    customContext?: any;
    iframe?: string;
    iframeUrl?: string;
    openInNewWindow?: boolean;
    payment?: Payment;
    uid?: string;
}

export interface PaymentInput {
    defaultValue?: string;
    hint?: string;
    label?: string;
    name?: string;
    options?: string;
    required?: boolean;
    type?: PaymentInputType;
}

export interface PaymentLog {
    data?: string;
    error?: boolean;
    id?: number;
    message?: string;
    paymentId?: number;
    referenceId?: string;
    status?: PaymentStatus;
    timestamp?: Date;
    type?: PaymentLogEventType;
}

export interface PaymentMediumProjection {
    address?: string;
    amount?: number;
    amountEuro?: number;
    created?: Date;
    cryptoTxReference?: string;
    currency?: string;
    id?: number;
    isCancellable?: boolean;
    paymentTxId?: number;
    provider?: string;
    status?: PaymentStatus;
    type?: PaymentType;
    uid?: string;
    updated?: Date;
}

export interface PaymentMethod {
    achBankTransfer?: boolean;
    addressRequired?: boolean;
    amountRequired?: boolean;
    attributes?: { [index: string]: string };
    canReuseAddress?: boolean;
    code?: string;
    depositEnabled?: boolean;
    destinationTag?: boolean;
    displayName?: string;
    group?: string;
    instantDepositEnabled?: boolean;
    isLatest?: boolean;
    isLatestCryptoDeposit?: boolean;
    isLatestCryptoWithdraw?: boolean;
    name?: string;
    networks?: CryptoNetwork[];
    networksEnabled?: boolean;
    provider?: string;
    recommendedWalletURL?: string;
    requireKycOnDeposit?: boolean;
    requireKycOnWithdraw?: boolean;
    showNetworkFee?: boolean;
    withdrawEnabled?: boolean;
    zeroNetworkFee?: boolean;
}

export interface PlayerOrder {
    amount?: number;
    currencyCode?: string;
    custom?: any;
    destinationTag?: string;
    method?: string;
    notes?: string;
    priority?: Priority;
    purchaseBundleId?: number;
    purchaseBundleName?: string;
    recipientAddress?: string;
    reuseAddressIfPossible?: boolean;
    type?: PaymentType;
}

export interface PlayerProfile {
    fallbackImages?: FallbackImages;
    isProfileVisible?: boolean;
    joinDate?: Date;
    screenName?: string;
    topGames?: PlayerProfileTopGame[];
    totalBetCount?: number;
    totalWagerEur?: number;
    userId?: number;
    userLevelView?: UserLevelView;
    userUid?: string;
}

export interface PlayerProfileTopGame {
    gameId?: number;
    imageHeight?: number;
    imageUrl?: string;
    imageWidth?: number;
    name?: string;
    rank?: number;
    studioName?: string;
}

export interface PlayerToPlayerTransferRequest {
    amount?: number;
    currency?: string;
    toUserUid?: string;
}

export interface PlayerTransaction {
    amount?: Money;
    attributes?: { [index: string]: string };
    id?: number;
    providerMaskedName?: string;
    timestamp?: Date;
}

export interface PlayerTransactionsRequest {
    currency?: string;
    limit?: number;
    offset?: number;
    type?: Product;
}

export interface PlayerTransactionsResponse {
    transactions?: PlayerTransaction[];
}

export interface PokerItem {
    allowMultiple?: boolean;
    category?: string;
    description?: string;
    id?: string;
    imageUrl?: string;
    isEquippable?: boolean;
    name?: string;
    nameId?: string;
    operatorId?: number;
    value?: number;
    voucherCurrencyCode?: string;
    voucherValue?: number;
}

export interface PokerPlayerCount {
    online?: number;
    seated?: number;
}

export interface ProfileVisibility {
    isProfileVisible?: boolean;
}

export interface Progress {
    createdDate?: Date;
    currentProgress?: number;
    invitedBy?: string;
    rewarded?: boolean;
    updatedDate?: Date;
    userUid?: string;
}

export interface Provider {
    styles?: { [P in Style]?: string };
}

export interface ProviderRewardResponse {
    errorCode?: number;
    message?: string;
    referenceCode?: string;
}

export interface PushSubscription {
    auth?: string;
    endpoint?: string;
    expirationTime?: number;
    key?: string;
}

export interface ReCaptchaFrontendSettings {
    actions?: ReCaptchaAction[];
    enabled?: boolean;
    siteKey?: string;
}

export interface RegistrationRequest {
    attributes?: { [index: string]: string };
    country?: string;
    currency?: string;
    deviceId?: string;
    email?: string;
    password?: string;
    phoneNumber?: string;
    principal?: UserLoginPrincipal;
    repeatPassword?: string;
    username?: string;
}

export interface RegistrationResponse {
    field?: string;
    passwordViolation?: PasswordViolation;
    status?: Status;
    userInfo?: UserInfo;
}

export interface RequestPrincipalVerification {
    principal?: string;
    verification?: LoginVerification;
}

export interface RequestWithdrawResponse {
    accepted?: boolean;
    paymentId?: number;
    paymentUid?: string;
    referenceId?: string;
    result?: PaymentResultCode;
}

export interface ResetPasswordRequest {
    address?: string;
    newPassword?: string;
    principal?: UserLoginPrincipal;
    resetPasswordCode?: string;
}

export interface ResolvedUid {
    source?: Source;
    userUid?: string;
}

export interface RewardStats {
    totalFreeSpins?: number;
    totalRewards?: number;
    totalRewardsCurrency?: string;
}

export interface RewardTemplate {
    created?: Date;
    currencyCode?: string;
    defaultAmount?: number;
    defaultCasinoGameId?: number;
    defaultNrOfFreeSpins?: number;
    description?: string;
    descriptionKey?: string;
    expireAfterDays?: number;
    iconUrl?: string;
    id?: number;
    imageUrl?: string;
    name?: string;
    product?: Product;
    rewardType?: RewardType;
    templateId?: string;
    titleKey?: string;
    translations?: RewardTemplateTranslation[];
    validForUserUntilDays?: number;
}

export interface RewardTemplateTranslation {
    id?: number;
    imageUrl?: string;
    language?: string;
}

export interface SSOLoginRequest extends LoginRequest {
    credential?: string;
    loginType?: LoginType;
    promoCode?: string;
}

export interface ScriptWidget {
    description?: string;
    name?: string;
    scriptUrl?: string;
    variableName?: string;
}

export interface SeoMetadata {
    canonicalUrl?: string;
    description?: string;
    keywords?: string;
    locale?: string;
    ogImageUrl?: string;
    title?: string;
}

export interface Settings {
    acquisitionScript?: string;
    amplitudeApiKey?: string;
    appInstallButtonsEnabled?: boolean;
    appNativePromptEnabled?: boolean;
    appPopupEnabled?: boolean;
    blinkLobbyUrl?: string;
    bonusEnabled?: boolean;
    bundleBonusCurrency?: string;
    canonicalBaseUrl?: string;
    casinoEnabled?: boolean;
    clientManifest?: string;
    contenfulSpaceId?: string;
    contentfulAccessToken?: string;
    countryBlockEnabled?: boolean;
    cssOverrideUrl?: string;
    currencies?: CurrencyDefinition[];
    currencyOrder?: string;
    customScripts?: string;
    defaultFiatExchangeCurrency?: string;
    delayAppInstallPopup?: number;
    displayFiatExchangeByDefault?: boolean;
    emailSignupAvailable?: boolean;
    facebookAppId?: string;
    faqPageEnabled?: boolean;
    fingerprintDomain?: string;
    fingerprintEnabled?: boolean;
    fingerprintPublicKey?: string;
    forceWithdrawCurrency?: string;
    freshChatConfig?: FreshchatConfig;
    freshChatEnabled?: boolean;
    freshChatHost?: string;
    freshChatWidgetSiteId?: string;
    freshChatWidgetToken?: string;
    googleAnalyticsId?: string;
    googleOneTapSettings?: GoogleOneTapFrontendSettings;
    id?: number;
    iosMediaJSON?: string;
    kycAllNewUsers?: boolean;
    kycAvailable?: boolean;
    kycAvailableNewUsers?: boolean;
    kycDepositNewUsers?: boolean;
    kycOnAllRequired?: boolean;
    kycOnDepositRequired?: boolean;
    kycOnPlayRequired?: boolean;
    kycOnWithdrawRequired?: boolean;
    kycPlayNewUsers?: boolean;
    kycWithdrawNewUsers?: boolean;
    languageOrder?: string;
    loginRedirectUrl?: string;
    loginRequestCoolDown?: number;
    loginRequestInterval?: number;
    loginThrottleEnabled?: boolean;
    loginsRequiredForPushPrompt?: number;
    matiClientId?: string;
    matiEnabled?: boolean;
    maxLoginCount?: number;
    maxVerificationAttempts?: number;
    menu?: Menu;
    mfaEnabled?: boolean;
    minimumAge?: number;
    noOfTimeBeforeHidingPrompt?: number;
    noOfTimeBeforePromptingAgain?: number;
    oneTapEnabled?: boolean;
    onramperCurrencies?: string;
    operatorIconUrl?: string;
    operatorName?: string;
    originalsEnabled?: boolean;
    phoneSignupAvailable?: boolean;
    pokerEnabled?: boolean;
    pushNotificationsEnabled?: boolean;
    pwaEnabled?: boolean;
    pwaEnabledAndroid?: boolean;
    pwaEnabledIOS?: boolean;
    pwaEnabledWindows?: boolean;
    racingEnabled?: boolean;
    reCaptchaSettings?: ReCaptchaFrontendSettings;
    requireEmailVerifiedForPasswordReset?: boolean;
    requirePhoneVerifiedForPasswordReset?: boolean;
    requireUserChannelVerification?: boolean;
    requiredUserAttributes?: UserAttributeDefinition[];
    sessionAuth?: boolean;
    showCurrencySelectOnSignup?: boolean;
    showUserLevel?: boolean;
    skipDepositPageOnRegister?: boolean;
    sportsbookConfig?: SportsbookConfig;
    sportsbookEnabled?: boolean;
    sportsbookProvider?: SportsbookProvider;
    startPokerOnOpen?: boolean;
    strapiApiUrl?: string;
    termsVersion?: string;
    tippingEnabled?: boolean;
    title?: string;
    tokenLoginEnabled?: boolean;
    transferLimits?: TransferLimit[];
    useAmplitude?: boolean;
    useInfoTextSignup?: boolean;
    useStoreInsteadOfDeposit?: boolean;
    vouchersEnabled?: boolean;
    widgets?: ScriptWidget[];
    zendeskEnabled?: boolean;
    zendeskKeyId?: string;
    zendeskSharedSecret?: string;
    zendeskSharedSecretConfigured?: boolean;
    zendeskWidgetKey?: string;
}

export interface SiteMap {
    siteMapUrls?: SiteMapUrl[];
}

export interface SiteMapIndex {
    sitemaps?: IndexSiteMap[];
}

export interface SiteMapUrl {
    location?: string;
    xhtmlLinks?: XhtmlLink[];
}

export interface SportsbookConfig {
    enabledConfig?: boolean;
    providers?: SportsbookProviderOption[];
}

export interface SportsbookProviderOption {
    pathname?: string;
    provider?: SportsbookProvider;
}

export interface StyleSize {
    height?: number;
    width?: number;
}

export interface SubMenu {
    defaultCasinoPage?: boolean;
    icon?: string;
    id?: number;
    name?: string;
    tabs?: SubMenuTab[];
}

export interface SubMenuTab {
    icon?: string;
    id?: number;
    name?: string;
    target?: string;
    translations?: { [index: string]: string };
    type?: MenuItemType;
    url?: string;
}

export interface TokenLoginRequest extends LoginRequest {
    secret?: string;
    token?: string;
}

export interface TradableLoginRequest extends AppIntegrationLoginRequest {
    tradable?: string;
}

export interface TransferLimit {
    currency?: string;
    defaultDepositAmount?: number;
    firstTimeDepositLimit?: number;
    maxDepositAmount?: number;
    maxWithdrawAmount?: number;
    minDepositAmount?: number;
    minTipAmount?: number;
    minWithdrawAmount?: number;
}

export interface TurnoverContributions {
    contributions?: Contribution[];
    id?: number;
    name?: string;
}

export interface UnorderedListRequest {
    limit?: number;
    offset?: number;
}

export interface UpcomingCashback {
    amount?: number;
    claimable?: boolean;
    configId?: number;
    configName?: string;
    currency?: string;
    effectiveFraction?: number;
    frequency?: CashbackFrequency;
    notEligibleReason?: CashbackNotEligibleReason;
    requiredLevel?: number;
    scheduledPayoutTime?: Date;
    translationKey?: string;
    type?: CashbackType;
}

export interface UpdatePaymentResponse {
    message?: string;
    payment?: Payment;
    result?: UpdateResult;
}

export interface UserAttributeDefinition {
    attributeKey?: string;
    descriptionTranslationKey?: string;
    id?: number;
    maxLength?: number;
    minLength?: number;
    nameTranslationKey?: string;
    options?: string;
    ordinal?: number;
    regex?: string;
    required?: boolean;
    type?: AttributeType;
    userWriteAccess?: UserWriteAccess;
}

export interface UserBonusListResponse extends ListResponse {
    items?: UserBonusView[];
}

export interface UserBonusView {
    bonusConfig?: BonusConfig;
    currency?: string;
    currentTurnover?: number;
    expires?: Date;
    id?: number;
    parachuteBonusBalance?: number;
    parachuteBonusPhase?: boolean;
    pendingCount?: number;
    pendingSum?: number;
    status?: UserBonusStatus;
    timestamp?: Date;
    totalBonusAmount?: number;
    turnoverRequirement?: number;
    userId?: number;
}

export interface UserDeposit {
    formSteps?: FormStep[];
    verification?: UserVerificationRequirements;
}

export interface UserGameReward {
    amount?: number;
    claimTime?: Date;
    created?: Date;
    currencyCode?: string;
    expires?: Date;
    gameId?: number;
    id?: number;
    integration?: GameIntegration;
    messageRead?: boolean;
    nrOfFreeSpins?: number;
    providerReference?: string;
    providerResponse?: ProviderRewardResponse;
    removed?: boolean;
    rewardTemplate?: RewardTemplate;
    status?: RewardStatus;
    userId?: number;
}

export interface UserGameRewardQueryResult extends ListResponse {
    items?: UserGameReward[];
    queryLimit?: number;
    queryOffset?: number;
}

export interface UserInfo {
    attributes?: { [index: string]: string };
    avatarUrl?: string;
    blocked?: boolean;
    blockedStatus?: BlockedStatus;
    country?: string;
    currencies?: Currency[];
    currentLevel?: number;
    deviceToken?: string;
    email?: string;
    emailVerified?: boolean;
    errorMessage?: string;
    internalUserId?: number;
    kycFunctions?: KycFunctionType[];
    kycStatus?: KycStatus;
    kycVerified?: boolean;
    locale?: string;
    loggedIn?: boolean;
    mfaProvider?: MultiFactorAuthProvider;
    mfaStatus?: MultiFactorAuthStatus;
    newUser?: boolean;
    oneTimeTokenLogin?: boolean;
    phoneNumber?: string;
    phoneNumberVerified?: boolean;
    principalVerified?: boolean;
    responseContext?: string;
    responseStatus?: LoginResponseStatus;
    secret?: string;
    token?: string;
    tokenRefId?: number;
    userSettings?: { [index: string]: string };
    userUid?: string;
    username?: string;
    verificationChannel?: LoginVerification;
}

export interface UserInput {
    field?: UserPrimaryField;
    hidden?: boolean;
    minAge?: number;
    repeatInput?: boolean;
    required?: boolean;
    type?: InputType;
    userAttributeKey?: string;
}

export interface UserInputGroup {
    inputs?: UserInput[];
    name?: string;
    translationKey?: string;
}

export interface UserJourney {
    deposit?: UserDeposit;
    login?: UserLogin;
    registration?: UserRegistration;
    userLoginPrincipals?: UserLoginPrincipal[];
    withdraw?: UserWithdraw;
}

export interface UserJourneyAndAttributes {
    countries?: Country[];
    journey?: UserJourney;
    kycRequired?: boolean;
    userAttributes?: { [index: string]: UserAttributeDefinition };
}

export interface UserLevelView {
    currentLevel?: number;
    currentLevelName?: string;
    nextLevelName?: string;
    nextLevelProgressionPercentage?: number;
}

export interface UserLogin {
    verifications?: UserVerificationRequirements;
}

export interface UserMessage {
    created?: Date;
    delivered?: boolean;
    deliveredTimestamp?: Date;
    hideToast?: boolean;
    id?: number;
    imageUrl?: string;
    message?: string;
    meta?: UserMessageMeta;
    preamble?: string;
    read?: boolean;
    showPreambleInMessage?: boolean;
    title?: string;
    userId?: number;
}

export interface UserMessageMeta {
    category?: UserMessageCategory;
    data?: { [index: string]: string };
    type?: UserMessageType;
}

export interface UserMessageMinimalProjection {
    created?: Date;
    delivered?: boolean;
    deliveredTimestamp?: Date;
    id?: number;
    read?: boolean;
    title?: string;
    userId?: number;
}

export interface UserRegistration {
    exclude?: UserLoginPrincipal[];
    formSteps?: FormStep[];
    riskCollectionId?: number;
    verification?: UserVerificationRequirements;
}

export interface UserVerificationRequirements {
    kyc?: boolean;
}

export interface UserWithdraw {
    formSteps?: FormStep[];
    verification?: UserVerificationRequirements;
}

export interface VoucherRedemptionResult {
    amount?: number;
    code?: VoucherRedemptionResultCode;
    currency?: string;
}

export interface WidgetAuthRequest {
    requestDate?: string;
    userId?: number;
    userUid?: string;
}

export interface WidgetAuthResponse {
    loginToken?: string;
    userId?: number;
}

export interface WidgetAuthentication {
    authenticationRequired?: boolean;
    error?: boolean;
    token?: string;
    variableName?: string;
}

export interface WithdrawContext {
    bankTransferContext?: BankTransferContext;
    cryptoContext?: CryptoWithdrawContext;
    customContext?: any;
    inputOrders?: { [index: string]: string[] };
    inputs?: PaymentInput[];
    kycRequired?: boolean;
    maxWithdraw?: number;
    minWithdraw?: number;
    permitted?: WithdrawPermitted;
    preReserveFunds?: boolean;
    providerProperties?: { [index: string]: string };
}

export interface XenditWithdrawContext {
    input?: PaymentInput[];
}

export interface XhtmlLink {
    href?: string;
    hreflang?: string;
    rel?: string;
}

export interface ZendeskJwtResponse {
    token?: string;
}

export type RestResponse<R> = Promise<R>;

export enum AccountRole {
    MAIN = "MAIN",
    RAKE = "RAKE",
    WALLET = "WALLET",
    BONUS = "BONUS",
    PROMOTION = "PROMOTION",
}

export enum AppContext {
    MAYAMINIAPP = "MAYAMINIAPP",
    GLIFE = "GLIFE",
}

export enum AppMode {
    NONE = "NONE",
    PWA = "PWA",
    NATIVE = "NATIVE",
    EMBEDDED = "EMBEDDED",
}

export enum AttributeType {
    PUBLIC = "PUBLIC",
    PRIVATE = "PRIVATE",
    SYSTEM = "SYSTEM",
    SYSTEM_INTERNAL = "SYSTEM_INTERNAL",
}

export enum AwardType {
    CLAIMED = "CLAIMED",
    RUNNING = "RUNNING",
    COMPLETED = "COMPLETED",
}

export enum BlockedStatus {
    NONE = "NONE",
    BLOCKED_BY_ADMIN = "BLOCKED_BY_ADMIN",
    SELF_EXCLUSION = "SELF_EXCLUSION",
    BLOCKED_COUNTRY = "BLOCKED_COUNTRY",
}

export enum BonusLogicType {
    PARACHUTE = "PARACHUTE",
    BOUNTY = "BOUNTY",
}

export enum BonusOfferStatus {
    OPEN = "OPEN",
    EXPIRED = "EXPIRED",
    CANCELED = "CANCELED",
    CLAIMED = "CLAIMED",
    BLOCKED = "BLOCKED",
}

export enum BonusPaymentType {
    DIRECT = "DIRECT",
    CASH_REWARD = "CASH_REWARD",
}

export enum BonusStatus {
    DISABLED = "DISABLED",
    ENABLED = "ENABLED",
    ARCHIVED = "ARCHIVED",
}

export enum BonusStatusAlert {
    RED = "RED",
    YELLOW = "YELLOW",
    GREEN = "GREEN",
}

export enum BundleType {
    purchase = "purchase",
    signOnBonus = "signOnBonus",
}

export enum CashbackFrequency {
    INSTANT = "INSTANT",
    DAILY = "DAILY",
    WEEKLY = "WEEKLY",
    MONTHLY = "MONTHLY",
}

export enum CashbackNotEligibleReason {
    USER_LEVEL_TOO_LOW = "USER_LEVEL_TOO_LOW",
}

export enum CashbackType {
    RAKEBACK = "RAKEBACK",
    CASHBACK = "CASHBACK",
}

export enum CasinoGameAspectRatio {
    R_16_9 = "R_16_9",
    R_4_3 = "R_4_3",
    R_3_4 = "R_3_4",
    R_9_16 = "R_9_16",
}

export enum CasinoGameType {
    ARCADE_GAMES = "ARCADE_GAMES",
    SLOTS = "SLOTS",
    LIVE_CASINO = "LIVE_CASINO",
    TABLE_GAMES = "TABLE_GAMES",
    VIDEO_POKER = "VIDEO_POKER",
    OTHER = "OTHER",
    VIRTUAL_SPORTS = "VIRTUAL_SPORTS",
    BINGO = "BINGO",
}

export enum CasinoLobbyCategoryType {
    GAME_SELECTION = "GAME_SELECTION",
    CONTENT = "CONTENT",
    STUDIO_SELECTION = "STUDIO_SELECTION",
}

export enum ContributionProduct {
    CASINO = "CASINO",
    SPORTSBOOK = "SPORTSBOOK",
    POKER = "POKER",
    RACING = "RACING",
}

export enum CryptoOnrampProvider {
    NONE = "NONE",
    ONRAMPER = "ONRAMPER",
    BANXA = "BANXA",
    CFX = "CFX",
    PULSE = "PULSE",
    REMINT = "REMINT",
}

export enum DepositResultCode {
    OK = "OK",
    DECLINED = "DECLINED",
    PENDING_VERIFICATION = "PENDING_VERIFICATION",
    ERROR = "ERROR",
    NOT_SUPPORTED = "NOT_SUPPORTED",
    OVER_LIMIT = "OVER_LIMIT",
    ACCOUNT_ALREADY_EXISTS = "ACCOUNT_ALREADY_EXISTS",
}

export enum DepositRewardType {
    FREESPINS = "FREESPINS",
    FREEBET = "FREEBET",
    CASH = "CASH",
}

export enum GameDisplay {
    FIXED = "FIXED",
    SCALE_OUT = "SCALE_OUT",
    EMBEDDED = "EMBEDDED",
}

/**
 * Values:
 * - `ALL`
 * - `INTERNAL`
 * - `PAYMENTS`
 * - `CUBEIA`
 * - `SONG88`
 * - `BOOONGO`
 * - `LATROBET`
 * - `SA_GAMING`
 * - `NUCLEUS`
 * - `ULTRAPLAY`
 * - `QTECH`
 * - `SPRIBE`
 * - `HUB88`
 * - `ZITRO`
 * - `SABA`
 * - `IMOON`
 * - `FLOW_GAMING`
 * - `PARIPLAY`
 * - `CHERRY`
 * - `REFERENCE_PROVIDER`
 * - `JILI`
 * - `SLOTEGRATOR`
 * - `ST8`
 * - `BIGPOT`
 * - `BETBY`
 * - `EVOLUTION`
 * - `PRAGMATIC_PLAY`
 * - `FA_CHAI`
 * - `MAYAMINIAPP` - @deprecated
 * - `BLINK`
 * - `ZENITH`
 */
export enum GameIntegration {
    ALL = "ALL",
    INTERNAL = "INTERNAL",
    PAYMENTS = "PAYMENTS",
    CUBEIA = "CUBEIA",
    SONG88 = "SONG88",
    BOOONGO = "BOOONGO",
    LATROBET = "LATROBET",
    SA_GAMING = "SA_GAMING",
    NUCLEUS = "NUCLEUS",
    ULTRAPLAY = "ULTRAPLAY",
    QTECH = "QTECH",
    SPRIBE = "SPRIBE",
    HUB88 = "HUB88",
    ZITRO = "ZITRO",
    SABA = "SABA",
    IMOON = "IMOON",
    FLOW_GAMING = "FLOW_GAMING",
    PARIPLAY = "PARIPLAY",
    CHERRY = "CHERRY",
    REFERENCE_PROVIDER = "REFERENCE_PROVIDER",
    JILI = "JILI",
    SLOTEGRATOR = "SLOTEGRATOR",
    ST8 = "ST8",
    BIGPOT = "BIGPOT",
    BETBY = "BETBY",
    EVOLUTION = "EVOLUTION",
    PRAGMATIC_PLAY = "PRAGMATIC_PLAY",
    FA_CHAI = "FA_CHAI",
    /**
     * @deprecated
     */
    MAYAMINIAPP = "MAYAMINIAPP",
    BLINK = "BLINK",
    ZENITH = "ZENITH",
}

export enum GameOrder {
    RELEASE_DATE = "RELEASE_DATE",
    POPULARITY = "POPULARITY",
    ALPHABETICAL = "ALPHABETICAL",
}

export enum InputType {
    LOGIN_PRINCIPAL = "LOGIN_PRINCIPAL",
    EMAIL = "EMAIL",
    PHONE = "PHONE",
    PASSWORD = "PASSWORD",
    ACCEPT_TERMS = "ACCEPT_TERMS",
    AUTO_ACCEPT_TERMS = "AUTO_ACCEPT_TERMS",
    COUNTRY = "COUNTRY",
    TEXT = "TEXT",
    DATE_OF_BIRTH = "DATE_OF_BIRTH",
    DATE = "DATE",
    CHECKBOX = "CHECKBOX",
    CHECKBOX_CHECKED = "CHECKBOX_CHECKED",
    PROMO_CODE = "PROMO_CODE",
}

export enum JurisdictionName {
    NONE = "NONE",
    UNREGULATED_EUROPE = "UNREGULATED_EUROPE",
    PAGCOR = "PAGCOR",
    UNREGULATED_ASIA = "UNREGULATED_ASIA",
}

export enum KycFunctionType {
    ALL = "ALL",
    REGISTRATION = "REGISTRATION",
    WITHDRAW = "WITHDRAW",
    DEPOSIT = "DEPOSIT",
    PLAY = "PLAY",
    KYC_AVAILABLE = "KYC_AVAILABLE",
}

export enum KycStatus {
    NOT_STARTED = "NOT_STARTED",
    PENDING = "PENDING",
    REVIEW_NEEDED = "REVIEW_NEEDED",
    REJECTED = "REJECTED",
    VERIFIED = "VERIFIED",
}

export enum LaunchBlockReason {
    CASINO_DISABLED = "CASINO_DISABLED",
    STUDIO_DISABLED = "STUDIO_DISABLED",
    INTEGRATION_DISABLED = "INTEGRATION_DISABLED",
    COUNTRY_BLOCKED = "COUNTRY_BLOCKED",
}

export enum LaunchStatus {
    SUCCESS = "SUCCESS",
    COUNTRY_BLOCKED = "COUNTRY_BLOCKED",
    CURRENCY_NOT_SUPPORTED = "CURRENCY_NOT_SUPPORTED",
    KYC_REQUIRED = "KYC_REQUIRED",
    PROVIDER_UNAVAILABLE = "PROVIDER_UNAVAILABLE",
}

export enum LoginResponseStatus {
    NONE = "NONE",
    SUCCESS = "SUCCESS",
    AUTHENTICATION_FAILED = "AUTHENTICATION_FAILED",
    VERIFICATION_REQUIRED = "VERIFICATION_REQUIRED",
    FAILED = "FAILED",
    BLOCKED = "BLOCKED",
    SELF_EXCLUDED = "SELF_EXCLUDED",
    FB_EMAIL_ALREADY_EXIST = "FB_EMAIL_ALREADY_EXIST",
    THIRD_PARTY_SSO_USER_EXIST = "THIRD_PARTY_SSO_USER_EXIST",
    THIRD_PARTY_SSO_DEFERRED_SIGNUP = "THIRD_PARTY_SSO_DEFERRED_SIGNUP",
    BLOCKED_COUNTRY = "BLOCKED_COUNTRY",
    MULTI_FACTOR_AUTH_REQUIRED = "MULTI_FACTOR_AUTH_REQUIRED",
    MULTI_FACTOR_AUTH_FAILED = "MULTI_FACTOR_AUTH_FAILED",
    ACCEPT_TERMS_REQUIRED = "ACCEPT_TERMS_REQUIRED",
    UNDER_AGE = "UNDER_AGE",
    MANUAL_APPROVAL_REQUIRED = "MANUAL_APPROVAL_REQUIRED",
    LOGIN_DISABLED = "LOGIN_DISABLED",
    NDRP_BLOCKED = "NDRP_BLOCKED",
}

export enum LoginType {
    MANUAL = "MANUAL",
    FACEBOOK = "FACEBOOK",
    TOKEN = "TOKEN",
    MAYAMINIAPP = "MAYAMINIAPP",
    GLIFE = "GLIFE",
    GOOGLE = "GOOGLE",
    DISCORD = "DISCORD",
    TELEGRAM = "TELEGRAM",
    MOCK = "MOCK",
}

export enum LoginVerification {
    EMAIL = "EMAIL",
    PHONE = "PHONE",
    USERNAME = "USERNAME",
    TOKEN = "TOKEN",
    OAUTH = "OAUTH",
}

export enum MaintenanceCategory {
    ALL = "ALL",
    SPORTSBOOK = "SPORTSBOOK",
    CASINO = "CASINO",
    POKER = "POKER",
    RACING = "RACING",
}

export enum MenuComponentType {
    LOGIN_REGISTER = "LOGIN_REGISTER",
    USER_LEVEL = "USER_LEVEL",
    CASHBACK = "CASHBACK",
    NONE = "NONE",
}

export enum MenuItemType {
    POKER = "POKER",
    CASINO = "CASINO",
    SPORTSBOOK = "SPORTSBOOK",
    RACING = "RACING",
    CUSTOM = "CUSTOM",
}

export enum MenuPosition {
    FIXED = "FIXED",
    ABSOLUTE = "ABSOLUTE",
}

export enum MultiFactorAuthProvider {
    OTP = "OTP",
    EMAIL = "EMAIL",
    SMS = "SMS",
}

export enum MultiFactorAuthStatus {
    DISABLED = "DISABLED",
    PENDING = "PENDING",
    ENABLED = "ENABLED",
}

export enum NotEligibleReason {
    NONE = "NONE",
    NO_AWARD_RATE = "NO_AWARD_RATE",
}

export enum PasswordViolation {
    TOO_SHORT = "TOO_SHORT",
    TOO_LONG = "TOO_LONG",
    COMMON = "COMMON",
    MISSING_UPPERCASE = "MISSING_UPPERCASE",
    MISSING_LOWERCASE = "MISSING_LOWERCASE",
    MISSING_NUMBER = "MISSING_NUMBER",
    MISSING_SPECIAL = "MISSING_SPECIAL",
}

export enum PaymentInputType {
    TEXT = "TEXT",
    PHONE_NUMBER = "PHONE_NUMBER",
    EMAIL = "EMAIL",
    SELECT = "SELECT",
}

export enum PaymentLogEventType {
    INITIATED = "INITIATED",
    CALLBACK_RECEIVED = "CALLBACK_RECEIVED",
    VERIFICATION_FAILED = "VERIFICATION_FAILED",
    DECLINED = "DECLINED",
    INTERNAL_TRANSFER_COMPLETE = "INTERNAL_TRANSFER_COMPLETE",
    INTERNAL_TRANSFER_FAILED = "INTERNAL_TRANSFER_FAILED",
    CANCELED = "CANCELED",
    FAILED = "FAILED",
    COMPLETED = "COMPLETED",
    RESOLVED = "RESOLVED",
    GENERIC = "GENERIC",
}

export enum PaymentPermitted {
    YES = "YES",
    NO = "NO",
    NO_WRONG_CURRENCY = "NO_WRONG_CURRENCY",
    NO_GENERAL_ERROR = "NO_GENERAL_ERROR",
    NO_BLOCKED = "NO_BLOCKED",
    NO_USER_NOT_FOUND = "NO_USER_NOT_FOUND",
    NO_LIMIT = "NO_LIMIT",
}

export enum PaymentResultCode {
    OK = "OK",
    DECLINED = "DECLINED",
    DECLINED_REQUEST_ALREADY_OPEN = "DECLINED_REQUEST_ALREADY_OPEN",
    DECLINED_NO_DEPOSIT_FOUND = "DECLINED_NO_DEPOSIT_FOUND",
    DECLINED_NO_TARGET_ADDRESS_SET = "DECLINED_NO_TARGET_ADDRESS_SET",
    DECLINED_DEPOSITS_WAITING_TO_CLEAR = "DECLINED_DEPOSITS_WAITING_TO_CLEAR",
    DECLINED_AMOUNT_TOO_LOW = "DECLINED_AMOUNT_TOO_LOW",
    DECLINED_BONUS_ACTIVE = "DECLINED_BONUS_ACTIVE",
    DECLINED_KYC_REQUIRED = "DECLINED_KYC_REQUIRED",
    DECLINED_MISSING_AUTH_DATA = "DECLINED_MISSING_AUTH_DATA",
    DECLINED_MISSING_PHONE_NUMBER = "DECLINED_MISSING_PHONE_NUMBER",
    DECLINED_PHONE_NUMBER_INVALID = "DECLINED_PHONE_NUMBER_INVALID",
    DECLINED_ACCOUNT_BLOCKED = "DECLINED_ACCOUNT_BLOCKED",
    DECLINED_ALREADY_REVERSED = "DECLINED_ALREADY_REVERSED",
    ERROR = "ERROR",
}

/**
 * Values:
 * - `INITIATED`
 * - `PENDING`
 * - `SETTLING`
 * - `FAILED`
 * - `FAILED_PERMANENTLY`
 * - `COMPLETED`
 * - `DECLINED` - @deprecated
 * - `CANCELED`
 * - `RESOLVED`
 * - `PLACEHOLDER`
 * - `APPLIED_WAITING_TO_CLEAR` - @deprecated
 */
export enum PaymentStatus {
    INITIATED = "INITIATED",
    PENDING = "PENDING",
    SETTLING = "SETTLING",
    FAILED = "FAILED",
    FAILED_PERMANENTLY = "FAILED_PERMANENTLY",
    COMPLETED = "COMPLETED",
    /**
     * @deprecated
     */
    DECLINED = "DECLINED",
    CANCELED = "CANCELED",
    RESOLVED = "RESOLVED",
    PLACEHOLDER = "PLACEHOLDER",
    /**
     * @deprecated
     */
    APPLIED_WAITING_TO_CLEAR = "APPLIED_WAITING_TO_CLEAR",
}

export enum PaymentType {
    DEPOSIT = "DEPOSIT",
    WITHDRAWAL = "WITHDRAWAL",
    AUTH = "AUTH",
    BONUS = "BONUS",
    CORRECTION = "CORRECTION",
}

export enum Priority {
    HIGH = "HIGH",
    MEDIUM = "MEDIUM",
    LOW = "LOW",
}

export enum Product {
    POKER = "POKER",
    CASINO = "CASINO",
    SPORTSBOOK = "SPORTSBOOK",
    PAYMENT = "PAYMENT",
    RACING = "RACING",
    MAYAMINIAPP = "MAYAMINIAPP",
    GLIFE = "GLIFE",
}

export enum ReCaptchaAction {
    login = "login",
    register = "register",
    recoverPassword = "recoverPassword",
    requestPrincipalVerification = "requestPrincipalVerification",
}

export enum RewardStatus {
    NEW = "NEW",
    CLAIMED = "CLAIMED",
}

export enum RewardType {
    freespins = "freespins",
    cash = "cash",
    freebet = "freebet",
}

export enum RuleTriggerType {
    ABSOLUTE_COUNT = "ABSOLUTE_COUNT",
    EVERY_TIME = "EVERY_TIME",
    MANUAL = "MANUAL",
}

export enum SabaPlatform {
    DESKTOP = "DESKTOP",
    MOBILE = "MOBILE",
}

export enum Source {
    JWT_TOKEN = "JWT_TOKEN",
    SESSION = "SESSION",
}

export enum SportsbookProvider {
    SONG88 = "SONG88",
    ULTRAPLAY = "ULTRAPLAY",
    SABA = "SABA",
    BETBY = "BETBY",
}

export enum Status {
    SUCCESS = "SUCCESS",
    SCREEN_NAME_EXIST = "SCREEN_NAME_EXIST",
    EMAIL_EXIST = "EMAIL_EXIST",
    PHONE_EXIST = "PHONE_EXIST",
    INVALID_DATA = "INVALID_DATA",
    INVALID_CHARACTER = "INVALID_CHARACTER",
    BLOCKED_DOMAIN = "BLOCKED_DOMAIN",
    BLOCKED_IP = "BLOCKED_IP",
    BLOCKED_COUNTRY = "BLOCKED_COUNTRY",
    PHONE_INVALID_FORMAT = "PHONE_INVALID_FORMAT",
    UNDER_AGE = "UNDER_AGE",
    DENIED = "DENIED",
    INVALID_PROMO_CODE = "INVALID_PROMO_CODE",
}

export enum Style {
    main = "main",
    alternative = "alternative",
    promo = "promo",
    lite = "lite",
    originals = "originals",
}

export enum UpdateResult {
    OK = "OK",
    ERROR = "ERROR",
    ERROR_CANCEL_NOT_SUPPORTED = "ERROR_CANCEL_NOT_SUPPORTED",
    ERROR_BAD_PAYMENT_STATE = "ERROR_BAD_PAYMENT_STATE",
    ERROR_INTERNAL_TRANSFER = "ERROR_INTERNAL_TRANSFER",
    ERROR_NOT_FOUND = "ERROR_NOT_FOUND",
}

export enum UserBonusStatus {
    RUNNING = "RUNNING",
    COMPLETED = "COMPLETED",
    CANCELED = "CANCELED",
    EXPIRED = "EXPIRED",
    BUSTED = "BUSTED",
}

export enum UserLoginPrincipal {
    EMAIL = "EMAIL",
    PHONE_NUMBER = "PHONE_NUMBER",
}

export enum UserMessageCategory {
    GENERIC = "GENERIC",
    REWARD = "REWARD",
    BONUS = "BONUS",
    PAYMENT = "PAYMENT",
    GAME = "GAME",
}

export enum UserMessageType {
    GENERIC = "GENERIC",
    REWARD_RECEIVED = "REWARD_RECEIVED",
    WITHDRAW_DENIED = "WITHDRAW_DENIED",
    WITHDRAW_APPROVED = "WITHDRAW_APPROVED",
    WITHDRAW_CONFIRMATION_CODE = "WITHDRAW_CONFIRMATION_CODE",
    WITHDRAW_FAILED = "WITHDRAW_FAILED",
    BONUS_OFFERED = "BONUS_OFFERED",
    BONUS_ENDED = "BONUS_ENDED",
    BONUS_TURNOVER_COMPLETED = "BONUS_TURNOVER_COMPLETED",
    BONUS_PAID_OUT = "BONUS_PAID_OUT",
    DEPOSIT_COMPLETE = "DEPOSIT_COMPLETE",
    BET_WON = "BET_WON",
    BET_LOST = "BET_LOST",
    BET_REFUNDED = "BET_REFUNDED",
    BET_LIMIT_EXCEEDED = "BET_LIMIT_EXCEEDED",
    WIN_LIMIT_EXCEEDED = "WIN_LIMIT_EXCEEDED",
    BET_REJECTED = "BET_REJECTED",
    LEVEL_UP = "LEVEL_UP",
    TIP_RECEIVED = "TIP_RECEIVED",
    TESTING_MESSAGES = "TESTING_MESSAGES",
    DEPOSIT_REGISTERED = "DEPOSIT_REGISTERED",
}

export enum UserPrimaryField {
    loginPrincipal = "loginPrincipal",
    email = "email",
    phoneNumber = "phoneNumber",
    password = "password",
    termsAccepted = "termsAccepted",
}

export enum UserWriteAccess {
    NONE = "NONE",
    CREATE = "CREATE",
    CREATE_AND_UPDATE = "CREATE_AND_UPDATE",
}

export enum VoucherRedemptionResultCode {
    SUCCESS = "SUCCESS",
    FAILURE = "FAILURE",
    FAILURE_NOT_OPEN = "FAILURE_NOT_OPEN",
    FALIURE_WRONG_CODE = "FALIURE_WRONG_CODE",
    FAILURE_WRONG_USER = "FAILURE_WRONG_USER",
    FAILURE_ALREADY_REDEEMED = "FAILURE_ALREADY_REDEEMED",
    FAILURE_REVOKED = "FAILURE_REVOKED",
    FAILURE_EXPIRED = "FAILURE_EXPIRED",
}

export enum WithdrawPermitted {
    YES = "YES",
    REJECTED_NO_PREVIOUS_DEPOSIT_FOUND = "REJECTED_NO_PREVIOUS_DEPOSIT_FOUND",
    DEPOSITS_WAITING_TO_CLEAR = "DEPOSITS_WAITING_TO_CLEAR",
    NOT_SUPPORTED = "NOT_SUPPORTED",
    AMOUNT_TOO_SMALL = "AMOUNT_TOO_SMALL",
    BONUS_ACTIVE = "BONUS_ACTIVE",
    REQUEST_ALREADY_OPEN = "REQUEST_ALREADY_OPEN",
    KYC_REQUIRED = "KYC_REQUIRED",
    REJECTED_GENERIC = "REJECTED_GENERIC",
}

function uriEncoding(template: TemplateStringsArray, ...substitutions: any[]): string {
    let result = "";
    for (let i = 0; i < substitutions.length; i++) {
        result += template[i];
        result += encodeURIComponent(substitutions[i]);
    }
    result += template[template.length - 1];
    return result;
}
